import {
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCirclePlay,
  faMagnifyingGlassPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Carousel } from "@mantine/carousel";
import { ActionIcon, Card, Checkbox, ColorSwatch, Group, Input, Loader, Modal, NumberInput, Select, Tabs, } from "@mantine/core";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import {
  IconHeart,
  IconMinus,
  IconPlus,
  IconSquareRoundedPlus,
} from "@tabler/icons-react";
import _, { map, sample, set } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { BASE_URL } from "../../../api/EndPoints";
import { createB2BAPI } from "../../../api/Interceptor";
import badge from "../../../assets/badge.png";
import "../body/AppBody.css";
import "./ProductDetailsMainContent.css";
import B2BButton from "../../common/B2BButton";
import notify from "../../../utils/Notification";
import silkImage from "../../../assets/silk.jpg";
import { fab } from "@fortawesome/free-brands-svg-icons";
import TopBottomCollectionsPMC from "./TopBottomCollectionsPMC";

export const ProductDetailsMainContent = ({ reloadHeader }) => {
  const location = useLocation();
  const { pimUrl } = useParams();
  const queryParams = new URLSearchParams(location.search);
  const id = `PIM-${pimUrl.split("-").pop()}`;
  const [rolls, setRolls] = useState({});
  const variantId = queryParams.get("variantId");
  const navigate = useNavigate();
  const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageTop, setSelectedImageTop] = useState(null);
  const [imageDetails, setImageDetails] = useState(null);
  const [imageIndex, setImageIndex] = useState(null);

  const [selectedValues, setSelectedValues] = useState([]);
  const [itemAdded, setItemAdded] = useState(false);
  const [pim, setPim] = useState({});
  console.log(pim?.pimVariants, " pim variants ")
  const [currIdOfSelected, setCurrIdOfSelected] = useState(null)
  console.log(currIdOfSelected, " currIdOfSelected ")
  const [loading, setLoading] = useState(true);
  const [allMinPrice, setAllMinPrice] = useState(null);
  const [allMaxPrice, setAllMaxPrice] = useState(null);
  const ismobile = useMediaQuery("(max-width: 767px)");
  const isTab = useMediaQuery("(max-width: 991px)");
  const fabricSpecsRef = useRef(null);
  const pricingRef = useRef(null);
  const moqRef = useRef(null);
  const videoRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const [showScrollRight, setShowScrollRight] = useState(true);
  const [showScrollLeft, setShowScrollLeft] = useState(false);
  const [variantOrders, setVariantOrders] = useState({});
  console.log(variantOrders, "mkmk")
  const [kgPerRollByVariant, setKgPerRollByVariant] = useState({});
  const SCROLL_STEP = 300;
  const [mainContent, setMainContent] = useState(null);
  console.log(mainContent, "maincinteb")
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [profile, setProfile] = useState({});
  const [modalMessage, setModalMessage] = useState("");
  const [media, setMedia] = useState([]);
  const [images, setImages] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [categories, setCategories] = useState([]);
  const [garmentType, setGarmentType] = useState([]);
  const [colorOption, SetColorOption] = useState([]);
  const [page, setPage] = useState(0);
  const [similarProduct, setSimilarProduct] = useState([]);
  const [totalPage, setToatalPage] = useState(0);
  const [similarProductSlide, setSimilarProductSlide] = useState([]);
  const [minimumOrderRequired, setMinimumOrderRequired] = useState("");
  const [minimumOrder, setMinimumOrder] = useState("");
  const [pimVariantIds, setPimVariantIds] = useState([]);
  const [cart, setCart] = useState({});
  const [cartOptions, SetCartOptions] = useState([]);
  const [alreadyInCart, setAlreadyInCart] = useState({});
  const [stock, setStock] = useState({});
  const [fabricCodes, setFabricCodes] = useState({});
  const [backOrder, setBackOrder] = useState();
  const [combo, setCombo] = useState([]);
  const [swatchAvailable, setSwatchAvailabe] = useState(false);
  const [selectedSku, setSelectedSku] = useState(null);
  const [existComboSwatch, setExistComboSwatch] = useState();
  const [solidPatternVariant, setSolidPatternVariant] = useState(null);
  const [priceBook, setPriceBook] = useState([]);
  const [priceSlab, setPriceSlab] = useState([]);
  const [kgPerRoll, setKgPerRoll] = useState();
  const [selectedSkus, setSelectedSkus] = useState([]);
  const [swatch, setSwatch] = useState({});
  const [sampleCheck, setSampleCheck] = useState(true);
  const [selectedOrderType, setSelectedOrderType] = useState("WHOLESALE");
  const [opened, { open, close }] = useDisclosure(false);
  const isKg = pim?.product?.otherInformation?.unitOfMeasures?.isKg === true;
  const isYard =
    pim?.product?.otherInformation?.unitOfMeasures?.isYard === true;
  const isMeter =
    pim?.product?.otherInformation?.unitOfMeasures?.isMeter === true;
  const meterToKgFactor = pim?.product?.metrics?.meterPerKg;

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [bundle, setBundle] = useState([]);

  const [selectedRibIds, setSelectedRibIds] = useState([]);
  const dropdownRef = useRef();
  const [pimCheck, setPimcheck] = useState(false)
  const options = [
    {
      id: 1,
      title: "1x1 Rib",
      detail: "Lyocell 100% · 136 gsm · 58 inch",
    },

  ];
  const [ribKg, setRibKg] = useState(0)
  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
  };
  const [ribOrders, setRibOrders] = useState({});

  const getAffectedRibIds = (optionId) => {
    const isInCombo = combo?.includes(
      colorOption.find((o) => o.id === optionId)?.skucode
    );

    return isInCombo
      ? colorOption.filter((o) => combo.includes(o.skucode)).map((o) => o.id)
      : [optionId];
  };

  useEffect(() => {
    if (!pim?.pimVariants || pim.pimVariants.length === 0) {
      setAllMinPrice(null);
      setAllMaxPrice(null);
      return;
    }

    let allPrices = [];

    pim.pimVariants.forEach((variant) => {
      const base = variant.sellingPrice ?? 0;

      (variant.priceBooks || []).forEach((book) => {
        (book.priceSlab || []).forEach((slab) => {
          let price = base;

          if (slab.price && slab.price !== 0) {
            price = base - slab.price;
          }
          if (slab.discount != null && slab.discount !== 0) {
            price = price * (1 - slab.discount / 100);
          }
          price = Math.round(price * 100) / 100;
          allPrices.push(price);
        });
      });
    });

    const minPrice = allPrices.length > 0 ? Math.min(...allPrices) : null;
    const maxPrice = allPrices.length > 0 ? Math.max(...allPrices) : null;
    setPriceSlab(pim?.pimVariants?.[0]);
    setAllMinPrice(minPrice);
    setAllMaxPrice(maxPrice);

  }, [pim?.pimVariants, selectedOrderType]);



  const handleRibDecrement = (optionId) => {
    const affectedIds = getAffectedRibIds(optionId);

    setRibOrders((prev) => {
      const updated = { ...prev };
      affectedIds.forEach((id) => {
        const oldVal = prev[id]?.value || 0;
        const newVal = Math.max(0, oldVal - 1);

        let newKg = 0;

        if (bundle?.mandatory === true) {
          if (isKg) {
            if (newVal != null && bundle?.ratio != null) {
              newKg = isMeter

                ? ((newVal * meterToKgFactor) * bundle.ratio) / 100
                : (newVal * bundle.ratio) / 100;
            }
          }
        } else {
          if (isKg) {
            if (newVal != null && bundle?.ratio != null) {
              newKg = isMeter
                ? ((newVal * meterToKgFactor) * bundle.ratio) / 100
                : (newVal * bundle.ratio) / 100;
            }
          }
        }


        if (newVal === 0) {
          delete updated[id];
        } else {
          updated[id] = { value: newVal, kg: newKg };
        }
      });
      return updated;
    });


    setRibOrders((snapshot) => {
      const rollAfter = snapshot[affectedIds[0]]?.value || 0;
      if (rollAfter === 0) {
        removeFromSelectedRibs(affectedIds);
      }
      return snapshot;
    });
  };
  const handleRibIncrement = (optionId) => {
    const affectedIds = getAffectedRibIds(optionId);

    setRibOrders((prev) => {
      const updated = { ...prev };
      affectedIds.forEach((id) => {
        const oldVal = prev[id]?.value || 0;
        const newVal = Math.max(0, oldVal + 1);

        let newKg = 0;

        if (bundle?.mandatory === true) {
          if (isKg) {
            if (newVal != null && bundle?.ratio != null) {
              newKg = isMeter
                ? ((newVal * meterToKgFactor) * bundle.ratio) / 100
                : (newVal * bundle.ratio) / 100;
            }
          }
        } else {
          if (isKg) {
            if (newVal != null && bundle?.ratio != null) {
              newKg = isMeter
                ? ((newVal * meterToKgFactor) * bundle.ratio) / 100
                : (newVal * bundle.ratio) / 100;
            }
          }
        }


        if (newVal === 0) {
          delete updated[id];
        } else {
          updated[id] = { value: newVal, kg: newKg };
        }
      });
      return updated;
    });


    setRibOrders((snapshot) => {
      const rollAfter = snapshot[affectedIds[0]]?.value || 0;
      if (rollAfter === 0) {
        removeFromSelectedRibs(affectedIds);
      }
      return snapshot;
    });
  };

  useEffect(() => {

  }, [bundle, isKg, isMeter, ribKg, meterToKgFactor]);
  const filteredOptionss = colorOption.filter((option) => {
    const isInCombo = combo?.includes(option.skucode);

    if (selectedOrderType !== "WHOLESALE") {
      if (isInCombo) return false;
      if (!option.sample) return false;
    }
    return true;
  });




  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    const firstVariant =
      Array.isArray(pim.pimVariants) && pim.pimVariants.length > 0
        ? pim.pimVariants[0]
        : null;
    if (firstVariant && firstVariant.variants) {
      const foundVariant = firstVariant.variants.find(
        (vari) => vari.type === "Solid / Pattern"
      );
      setSolidPatternVariant(foundVariant || null);
    }
  }, [pim.pimVariants]);
  function getUniqueItemsWithCount(items) {
    const uniqueItemsMap = new Map();
    items.forEach((item) => {
      if (uniqueItemsMap.has(item.id)) {
        uniqueItemsMap.set(item.id, uniqueItemsMap.get(item.id) + 1);
      } else {
        uniqueItemsMap.set(item.id, 1);
      }
    });
    return Array.from(uniqueItemsMap, ([id, count]) => ({ id, count }));
  }

  useEffect(() => {
    setSelectedValues([]);
    setVariantOrders({});
    setRibOrders({});
  }, [selectedOrderType]);

  useEffect(() => {
    const totalKg = Object.values(variantOrders).reduce(
      (total, variant) => total + (variant.kg || 0),
      0
    );
    setMinimumOrder(totalKg);
  }, [variantOrders]);

  useEffect(() => {
    const isValid = Object.values(variantOrders).every((v) => {
      const moq = cartOptions[v.id]?.Wholesale ?? 20;
      return v.roll > 0 && v.kg >= moq;
    });
  }, [variantOrders, cartOptions]);
  useEffect(() => {
    setMainContent(media[0]);
    if (videoRef.current) {
      videoRef.current.play();
    }
  }, [location, media]);

  useEffect(() => {
    const initialMap = {};
    colorOption.forEach((opt) => {
      const sku = opt.skucode;
      if (combo?.includes(sku)) {
        const comboKgList = combo
          .map((comboSku) => stock[comboSku]?.kgPerRoll)
          .filter((kg) => typeof kg === "number" && !isNaN(kg));
        initialMap[opt.id] = comboKgList.length > 0 ? kgPerRoll || pim?.product?.otherInformation?.kilogram : 20;
      } else {
        initialMap[opt.id] =
          kgPerRoll ||
          pim?.product?.otherInformation?.kilogram ||
          20;
      }
    });
    setKgPerRollByVariant(initialMap);
  }, [colorOption, combo, stock, pim]);

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, clientWidth, scrollWidth } =
        scrollContainerRef.current;
      const maxScrollLeft = scrollWidth - clientWidth;
      const newScrollLeft = Math.min(scrollLeft + SCROLL_STEP, maxScrollLeft);
      scrollContainerRef.current.scrollTo({
        left: newScrollLeft,
        behavior: "smooth",
      });
      handleScroll();
    }
  };

  const isAnyComboTrue = Object.values(alreadyInCart).some(
    (item) => item.combo === true
  );

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft } = scrollContainerRef.current;
      const newScrollLeft = Math.max(scrollLeft - SCROLL_STEP, 0);
      scrollContainerRef.current.scrollTo({
        left: newScrollLeft,
        behavior: "smooth",
      });
      handleScroll();
    }
  };

  const handleScroll = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } =
        scrollContainerRef.current;
      const maxScrollLeft = scrollWidth - clientWidth;
      setShowScrollLeft(scrollLeft > 0);
      setShowScrollRight(scrollLeft < maxScrollLeft);
    }
  };

  useEffect(() => {
    async function getCart() {
      if (_.size(colorOption) > 0) {
        const colorIds = colorOption?.map((option) => option.id);
        try {
          const res = await B2B_API.get(`cart?pimVariantId=${colorIds}`).json();
          setAlreadyInCart(res.response);
        } catch (error) { }
      }
    }
    if (localStorage.getItem("token")) {
      getCart();
    }
  }, [colorOption]);



  const fetchWishListPImIds = async () => {
    try {
      const res = await B2B_API.get("wishlist/pim-ids").json();
      setPimVariantIds(res.response);
    } catch (error) { }
  };
  const existingCart = async () => {
    if (Object.keys(pim).length > 0) {
      const existComboSwatchRes = await B2B_API.get(
        `cart/comboSwatch?id=${pim?.pimId}`
      ).json();
      const existComboSwatch = existComboSwatchRes.response;
      setExistComboSwatch(existComboSwatch);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("token")) {
      existingCart();
      fetchWishListPImIds();
    }
  }, [pim]);

  const fetchMoq = async () => {
    try {
      const moqs = await B2B_API.get("customer/moq").json();
      const { sampleMoq, wholesaleMoq } = moqs?.response || {};
      return { sampleMoq, wholesaleMoq };
    } catch (error) {
      return {};
    }
  };

  useEffect(() => {
    const fetchAllProducts = async () => {
      try {
        const pimId = pimUrl.split("-");
        const response = await B2B_API.get(
          `pim/product/PIM-${pimId[pimId.length - 1]}`
        );
        const data = await response.json();
        const pimData = data.response;
        const Swatch = await B2B_API.get(
          `swatch/product?id=${pimData.product.id}`
        ).json();
        const bundleId = pimData?.bundleId;
        const bundles = await B2B_API.get(`bundle/getBundle?bundleId=${bundleId}`).json();
        setBundle(bundles.response);
        setPimcheck(pimData);
        setSwatchAvailabe(Swatch?.response?.swatchCount > 0);
        setSwatch(Swatch?.response);
        setCombo(pimData?.combo?.comboVariants);
        pimData.pimVariants = _.filter(
          pimData.pimVariants,
          (p) => p.status === "ACTIVE"
        );
        const skuIds = pimData.pimVariants.map((variant) => variant.variantSku);
        const res = await B2B_API.get(
          `stock/price?pimVariantSku=${skuIds}`
        ).json();
        const stocks = res.response;
        setStock(stocks);
        let sample1;
        let wholesale1;
        if (pimData.pimOtherInformation) {
          const { sampleMOQ, wholesaleMOQ } = pimData.pimOtherInformation;
          sample1 = sampleMOQ;
          wholesale1 = wholesaleMOQ;
        }
        if (!(sample1 || wholesale1) && localStorage.getItem("token")) {
          const res = await fetchMoq(sample1, wholesale1);
          if (!sample1) {
            sample1 = res.sampleMoq;
          }
          if (!wholesale1) {
            wholesale1 = res.wholesaleMoq;
          }
        }
        pimData.minPrice = Number.POSITIVE_INFINITY;
        pimData.maxPrice = Number.NEGATIVE_INFINITY;

        const priceBook = pimData?.pimVariants.map((item) => {
          return {
            variantId: item.id,
            priceSlabs: item.priceBook?.priceSlab || [
              {
                min: sample1,
                max: wholesale1,
                discount: 0,
                orderType: "SAMPLE",
                price: 0
              },
              {
                min: wholesale1,
                max: "",
                discount: 0,
                orderType: "WHOLESALE",
                price: 0
              },
            ],
            sellingPrice: item.sellingPrice,
            sku: item.variantSku,
            amountBased: item?.priceBook?.amountBased || false,
          };
        });
        let minPrice = Infinity;
        let maxPrice = -Infinity;

        pimData.minPrice = minPrice;
        pimData.maxPrice = maxPrice;
        setPriceBook(priceBook);
        setPim(pimData || {});
        const composition = pimData?.product?.fabricContent?.composition;
        const names = await replaceKeysWithNames(composition);
        setFabricCodes(names);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    const initializeComponent = async () => {
      setLoading(true);
      try {
        await fetchAllProducts();
        // Fetch additional data for logged-in users after main product data is loaded
        if (localStorage.getItem("token")) {
          try {
            await fetchWishListPImIds();
          } catch (e) {
            console.error("Error fetching wishlist:", e);
          }
        }
      } finally {
        setLoading(false);
      }
    };

    initializeComponent();
  }, [id, selectedOrderType]);
  const fetchCategoryName = async (code) => {
    const res = await B2B_API.get(`product-category/category/${code}`).json();
    return res?.response?.name;
  };

  const replaceKeysWithNames = async (categories) => {
    const results = {};
    for (const [code, value] of Object.entries(categories)) {
      const name = await fetchCategoryName(code);
      if (name) {
        results[`${name}(${code})`] = value;
      }
    }
    return results;
  };

  const colorVariantsCount = pim?.pimVariants?.length || 0;

  useEffect(() => {
    const newMedia = [];
    const newImages = [];
    if (pim) {
      const imageSrc = `${BASE_URL}${pim?.product?.image?.replace("/api", "")}`;
      const videoSrc = `${BASE_URL}${pim?.video?.replace("/api", "")}`;
      if (pim.video) {
        newImages.push(videoSrc, imageSrc);
        newMedia.push({
          type: "video",
          poster: imageSrc,
          src: videoSrc,
        });
      }
      if (pim.pimVariants) {
        pim.pimVariants.forEach((variant) => {
          if (variant.image !== null) {
            const variantImageSrc = `${BASE_URL}${variant.image.replace(
              "/api",
              ""
            )}`;
            newMedia.push({
              type: "image",
              src: variantImageSrc,
              sku: variant.variantSku,
              id: variant.id,
            });
            newImages.push(variantImageSrc);
          }
        });
      }
    }

    let sampleVarinat = [];
    pim?.product?.productVariants
      ?.filter((v) => v.allowSample)
      ?.map((item) => {
        sampleVarinat.push(item?.variantSku);
      });
    setMedia(newMedia);
    setImages(newImages);
    const colourOptions = [];
    _.map(pim.pimVariants, (pimv) => {
      const colorVariant = _.filter(
        pimv.variants,
        (v) => v.type === "Colour"
      )[0];
      if (colorVariant) {
        const color = {
          label: ` #${pimv.variantSku}-${_.capitalize(colorVariant?.value)}`,
          code: colorVariant.hexaColorCode,
          value: pimv.id,
          color: colorVariant.value,
          skucode: pimv.variantSku,
          id: pimv.id,
          image: pimv?.image,
          backOrder: pimv?.backOrder || false,
          sample: sampleVarinat.includes(pimv?.variantSku),
        };
        colourOptions.push(color);
      }
    });

    SetColorOption(colourOptions);
    const fetchAndSetCategories = async () => {
      const transformedCategories = await transformCategories();
      const garmentTypes = await transformCategories2();
      setCategories(transformedCategories);
      setGarmentType(garmentTypes);
    };

    fetchAndSetCategories();
    if (colourOptions.length > 0 && variantId) {
      const selectedColor = colourOptions.find(
        (item) => item.skucode === variantId
      );
      if (selectedColor) {
        setSelectedValue(selectedColor.id);
      }
    }
  }, [pim]);

  const toggleWishlist = async (pimVariantId, pimId, name) => {
    try {
      let url = 'wishlist/save';
      if (pimId) {
        url += `?pimId=${pimId}`;
      } else if (pimVariantId) {
        url += `?pimVariantId=${pimVariantId}`;
      }
      
      const targetId = pimId || pimVariantId;
      const isAlreadyInWishlist = _.includes(pimVariantIds, targetId);
      
      const response = await B2B_API.post(url).json();
      fetchWishListPImIds();
      
      if (!isAlreadyInWishlist && name) {
        const truncatedName = name.length > 25 ? name.substring(0, 25) + "..." : name;
        notify({
          error: false,
          success: true,
          title: `${truncatedName} added to wishlist`,
        });
      }
    } catch (error) {
      console.error("Error toggling wishlist:", error);
    }
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        if (garmentType?.length > 0) {
          const response = await B2B_API.post(
            `pim/searchFilter?page=${0}&size=${15}&sortData=New false`,
            {
              json: {
                [garmentType[0]?.name]: [
                  garmentType[garmentType.length - 1]?.categoryId,
                ],
              },
            }
          ).json();

          const pim = response?.response.content || [];
          const filteredProducts = pim
            .filter((p) => p.pimId !== id)
            .map((p) => ({
              ...p,
              pimVariants: p.pimVariants.filter((pv) => pv.status === "ACTIVE"),
            }));
          const totalPages = response?.response.totalPages;
          setToatalPage(totalPages);
          setSimilarProduct(filteredProducts);
        } else {
          const response = await B2B_API.post(
            `pim/searchFilter?page=${0}&size=${15}&sortData=New false`,
            {
              json: {
                [categories[0]?.name]: [
                  categories[categories.length - 1]?.categoryId,
                ],
              },
            }
          ).json();

          const pim = response?.response.content || [];
          const filteredProducts = pim
            .filter((p) => p.pimId !== id)
            .map((p) => ({
              ...p,
              pimVariants: p.pimVariants.filter((pv) => pv.status === "ACTIVE"),
            }));
          const totalPages = response?.response.totalPages;
          setToatalPage(totalPages);
          setSimilarProduct(filteredProducts);
        }
      } catch (error) {
        console.error("Failed to fetch products:", error);
      }
    };
    if (profile?.approveStatus === "APPROVED") fetchProducts();
  }, [categories, page]);

  const renderColorCode = (productVariants) => {
    if (productVariants && productVariants.length > 0) {
      const hexaColorCodes = productVariants.flatMap((item) =>
        item.variants?.filter((variant) => variant.hexaColorCode)
      );
      return (
        <div
          className={`colorchips ${_.size(hexaColorCodes) < 12 ? "borderable" : ""
            }`}
        >
          {_.map(hexaColorCodes, (hexa, index) => (
            <div
              key={index}
              className="colorchip"
              style={{ backgroundColor: hexa.hexaColorCode }}
            ></div>
          ))}
        </div>
      );
    } else {
      return <></>;
    }
  };

  const handleSampleCheck = () => {
    setMinimumOrder("");
    setSampleCheck((prev) => !prev);
  };
  const filteredOptions = colorOption.filter((option) => {
    const isInCombo = combo?.includes(option.skucode);

    if (selectedOrderType !== "WHOLESALE") {
      // if (isInCombo) return false;
      if (!option.sample) return false;
    }
    return true;
  });
  const nkv = mainContent?.sku;
  const matchingIndex = filteredOptions?.findIndex((o) => o.skucode === nkv) ?? 0;

  const reorderedOptions = filteredOptions
    ? [
      ...filteredOptions.filter((o) => o.skucode === nkv),
      ...filteredOptions.filter((o) => o.skucode !== nkv)
    ]
    : [];


  useEffect(() => {
    const similarSlide = similarProduct.map((item, index) => (
      <Carousel.Slide
        key={item.id || index}
      >
        <Card
          key={index}
          shadow="sm"
          padding={0}
          radius="md"
          style={{
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            height: "420px",
            minHeight: "420px",
            maxHeight: "420px",
          }}
          withBorder
          onClick={() => {
            navigate(item.landingUrl);
          }}
        >
          <img
            className="product-img"
            src={`${BASE_URL.replace("/api", "")}${item.image}?time=${Date?.now()}`}
          />
          <div style={{ padding: "12px" }}>
            {renderColorCode(item.pimVariants)}
            <div>
              <div
                style={{
                  color: "#788191",
                  fontWeight: "500",
                  fontSize: "12px",
                }}
              >
                {" "}
                {item?.articleCode}{" "}
              </div>
              <div
                style={{
                  fontWeight: "600",
                  marginBottom: "8px",
                }}
              >
                {item?.articleName}
              </div>
            </div>
            <div className="quality-price">
              <b className="price-container">&#8377; {item.channelPrice}</b>
            </div>
            <div className="quality-info">
              <div className="contents">
                <div className="f-600 item">
                  <div>{item.fabricContent?.value}</div>
                </div>
              </div>
            </div>
            <div style={{ fontSize: "11px" }}>
              <span className="m-r-0 weight-span">
                <span>{item.metrics?.weight}</span>
                <span>gsm</span>
              </span>
              <span className="m-l-4 m-r-4 weight-span">.</span>
              <span className="weight-span">
                {item.attributes["Fabric Type"]?.name}
              </span>
            </div>
            <div
              className="badges-quality m-t-8"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div className="badge-type">
                <img className="badge-img" src={`${badge}`} alt="Badge" />
                {_.size(getUniqueItemsWithCount(item.pimVariants))}
              </div>
              <div></div>
            </div>
          </div>
        </Card>
      </Carousel.Slide>
    ));
    setSimilarProductSlide(similarSlide);
  }, [similarProduct]);

  const fetchHeirarchy = async (parentId) => {
    let hierarchy = [];
    let currentId = parentId;
    while (currentId) {
      try {
        const res = await B2B_API.get(
          `product-category/category/${currentId}`
        ).json();
        const category = res.response;
        if (category) {
          hierarchy.push({
            name: category.name,
            hasParent: !!category.parentId,
            categoryId: category.categoryId,
          });
          currentId = category.parentId;
        } else {
          currentId = null;
        }
      } catch (error) {
        console.error("Error fetching category:", error);
        currentId = null;
      }
    }
    return hierarchy.reverse();
  };
  const getAffectedIds = (optionId) => {
    setCurrIdOfSelected(optionId)
    const isInCombo = combo?.includes(
      colorOption.find((o) => o.id === optionId)?.skucode
    );

    if (isInCombo && selectedOrderType !== "SAMPLE") {
      return colorOption
        .filter((o) => combo.includes(o.skucode))
        .map((o) => o.id);
    } else {
      return [optionId];
    }
  };
  useEffect(() => {
    const currentSlab = pim?.pimVariants?.find((o) => o?.id === currIdOfSelected)
    setPriceSlab(currentSlab)
  }, [currIdOfSelected, selectedOrderType])

  const addToSelected = (ids) => {
    setSelectedValues((prev) => Array.from(new Set([...prev, ...ids])));
  };

  const removeFromSelected = (ids) => {
    setSelectedValues((prev) => prev.filter((id) => !ids.includes(id)));
  };

  const handleIncrement = (optionId) => {
    const affectedIds = getAffectedIds(optionId);

    setVariantOrders((prev) => {
      const updated = { ...prev };
      affectedIds.forEach((id) => {
        const oldRoll = prev[id]?.roll || 0;
        const newRoll = oldRoll + 1;
        const newKg = newRoll * kgPerRoll;
        updated[id] = { roll: newRoll, kg: newKg };
      });
      return updated;
    });

    addToSelected(affectedIds);
  };
  const handleDecrement = (optionId) => {
    const affectedIds = getAffectedIds(optionId);

    setVariantOrders((prev) => {
      const updated = { ...prev };
      affectedIds.forEach((id) => {
        const oldRoll = prev[id]?.roll || 0;
        const newRoll = Math.max(0, oldRoll - 1);

        const newKg = newRoll * kgPerRoll;
        if (newRoll === 0) {
          delete updated[id];
        } else {
          updated[id] = { roll: newRoll, kg: newKg };
        }
      });
      return updated;
    });

    setVariantOrders((snapshot) => {
      const rollAfter = snapshot[affectedIds[0]]?.roll || 0;
      if (rollAfter === 0) {
        removeFromSelected(affectedIds);
      }
      return snapshot;
    });
  };

  const transformCategories = async () => {
    for (const [key, value] of Object.entries(pim?.attributes || {})) {
      if (key === "Fabric Type") {
        const hierarchy = await fetchHeirarchy(value.categoryId);
        return hierarchy;
      }
    }
    return null;
  };
  const transformCategories2 = async () => {
    for (const [key, value] of Object.entries(pim?.attributes || {})) {
      if (key === "Garment Type") {
        const hierarchy = await fetchHeirarchy(value.categoryId);
        return hierarchy;
      }
    }
    return null;
  };

  const renderMainContent = () => {
    return mainContent?.type === "video" ? (
      <video
        poster={mainContent?.src}
        ref={videoRef}
        src={`${mainContent?.src}`}
        muted={true}
        loop={true}
        autoPlay={true}
        playsInline={true}
      ></video>
    ) : (
      <div className="selected-thumbnail overlay cursor-pointer">
        <img
          className="app-img contain"
          src={`${mainContent?.src}`}
          alt="Wholesale Fabric Scuba (Polyester 93%,Spandex 7%)  Solid 450gsm-500gsm Piece dye"
          loading="lazy"
          draggable="false"
        />
      </div>
    );
  };
  const handleAllChange = () => ({

  })
  const slides = media.map((url) => (
    <Carousel.Slide
      key={url}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {url?.type === "video" ? (
        <div
          style={
            ismobile
              ? { width: "auto", height: "200px", overflow: "hidden" }
              : {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
                objectFit: "cover",
              }
          }
        >
          <video
            poster={url?.poster}
            ref={videoRef}
            src={`${url?.src}`}
            muted
            loop
            autoPlay
            playsInline
          />
        </div>
      ) : (
        <div
          style={
            ismobile
              ? { width: "auto", height: "200px", overflow: "hidden" }
              : {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
                objectFit: "cover",
              }
          }
        >
          <img
            className="app-img contain"
            src={`${url?.src}`}
            alt="Wholesale Fabric Scuba (Polyester 93%, Spandex 7%) Solid 450gsm-500gsm Piece dye"
            loading="lazy"
            draggable="false"
          />
        </div>
      )}
    </Carousel.Slide>
  ));

  const scrollToFabricSpecs = () => {
    const headerHeight = document.querySelector("nav").offsetHeight;
    const elementPosition =
      fabricSpecsRef.current.getBoundingClientRect().top +
      window.scrollY -
      headerHeight;
    window.scrollTo({
      top: elementPosition,
      behavior: "smooth",
    });
  };

  const scrollToPriceRef = () => {
    if (pricingRef.current) {
      pricingRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const scrollToMoqRef = () => {
    if (pricingRef.current) {
      pricingRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const handleScubaClick = (category) => {
    for (const [key, value] of Object.entries(pim?.attributes || {})) {
      const stateValue = { [key]: [value] };
      if (key === "Fabric Type") {
        navigate(`/fabrics?FabricType=${category.name}`, { state: { value: stateValue } });
      }
    }
  };

  const handleFabricFilterClick = async (fabricName, fabricCategoryId) => {
    const name = fabricName.replace(" ", "_");
    const res = await B2B_API.get(
      `product-category/category/${fabricCategoryId}`
    ).json();
    const fabricObject = {
      ...res.response,
      name: `${name} (0-100)%`,
      min: "0",
      max: "100",
      value: `${fabricCategoryId}(0-100)`,
    };
    navigate(`/fabrics?FabricContent=${name}`, {
      state: { value: { "Fabric Content": [fabricObject] } },
    });
  };

  useEffect(() => {
    if (localStorage.getItem("token")) {
      fetchAllProfile();
    }
  }, []);

  const fetchAllProfile = async () => {
    try {
      const res = await B2B_API.get(`customer/profile`);
      const data = await res.json();
      setProfile(data?.response || {});
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const handleQuantityChange = (qty) => {
    setMinimumOrder(qty);
  };
  const handleAddToCart = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setModalMessage("You need to log in to add items to the cart.");
      return setIsOpenModal(true);
    }

    if (profile?.approveStatus !== "APPROVED") {
      setModalMessage(
        "You are not approved yet. Please Contact your Sales Manager"
      );
      return setIsOpenModal(true);
    }

    const enteredVariantIds = Object.keys(variantOrders).filter(
      (id) => variantOrders[id]?.roll > 0
    );
    const enteredRibIds = Object.keys(ribOrders)
      .filter(id => (ribOrders[id]?.value || 0) > 0);


    if (enteredVariantIds.length === 0) {
      notify({
        error: true,
        success: false,
        title: "Please enter valid rolls for at least one color.",
      });
      return;
    }

    try {
      let alreadyAdded = [];
      let comboadded = false
      for (let variantId of enteredVariantIds) {
        const qtyData = variantOrders[variantId];

        if (!qtyData || !qtyData.kg || qtyData.kg <= 0) {
          const filteredOption = colorOption.find((c) => c.id === variantId);
          notify({
            error: true,
            title: `Please enter valid rolls for ${filteredOption?.color}`,
          });
          return;
        }

        const filteredOption = colorOption.find((c) => c.id === variantId);
        const skuCode = filteredOption ? filteredOption.skucode : null;

        let orderType = "";
        const sampleMin = cartOptions[variantId]?.SampleMin || 0;
        const wholesaleMin = cartOptions[variantId]?.Wholesale || 0;

        if (combo?.includes(skuCode && selectedOrderType !== "SAMPLE")) {
          orderType = "COMBO";
          if (alreadyAdded.includes(pim?.combo?.id)) {
            continue;
          }
          alreadyAdded.push(pim?.combo?.id);
        }

        const orderData = {
          pimId: pim.id,
          cartType: combo?.includes(skuCode) && selectedOrderType !== "SAMPLE" ? "COMBO" : selectedOrderType,
          quantity: qtyData.kg,
          pimVariantId: variantId,
          comboId: combo?.includes(skuCode) && selectedOrderType !== "SAMPLE" ? pim?.combo?.id : null,
        };

        if (combo?.includes(skuCode) && selectedOrderType !== "SAMPLE" && comboadded === false) {
          await B2B_API.post(`cart/combo/save`, { json: orderData });
          comboadded = true;
        } else if (orderData.cartType !== "COMBO") {
          await B2B_API.post(`cart/save`, { json: orderData });
        }
      }
      if (selectedOrderType !== "SAMPLE") {
        for (let ribId of enteredRibIds) {
          const { kg, value } = ribOrders[ribId];
          const bundleMatch = bundle?.bundleVariants?.find(b => b.fabricPimVariantId === ribId);

          const ribData = {
            pimId: bundle?.ribsPim?.id,
            rib: true,
            cartType: "WHOLESALE",
            quantity: bundle?.mandatory === true ? Math.ceil(value) : value,
            fabPimVariantId: ribId,
            pimVariantId: bundleMatch?.ribPimVariantId,
            bundleId: bundle?.bundleId,
          };

          await B2B_API.post("cart/save", { json: ribData });
        }
      }


      open();
      setItemAdded(true);
      setRibOrders({});
      setVariantOrders({});
      reloadHeader();
    } catch (error) {
      console.error("Error adding to cart:", error);
    }


  };
  const addToSelectedRibs = (ids) => {
    setSelectedRibIds((prev) => {
      const newSet = new Set([...prev, ...ids]);
      return Array.from(newSet);
    });
  };

  const removeFromSelectedRibs = (ids) => {
    setSelectedRibIds((prev) => prev.filter((id) => !ids.includes(id)));
  };
  const handleCloseModal = () => {
    setIsOpenModal(false);
  };
  const handleShowImage = (item, index) => {
    setSelectedImage(item.image);
    setImageDetails({
      id: item.id,
      color: item.color,
      skucode: item.skucode,
    });
    setImageIndex(index);
  };
  const scrollLeftIcon = () => {
    if (imageIndex > 0) {
      const newIndex = imageIndex - 1;
      setImageIndex(newIndex);
      setSelectedImage(colorOption[newIndex]);
    }
  };

  const scrollRightIcon = () => {
    if (imageIndex < colorOption.length - 1) {
      const newIndex = imageIndex + 1;
      setImageIndex(newIndex);
      setSelectedImage(colorOption[newIndex]);
    }
  };
  const swatchNotify = async () => {
    try {
      const res = await B2B_API.post(
        `swatchNotification/save?swatchId=${pim?.product?.productId}`
      );
      const data = await res.json();
      const pimId = pimUrl.split("-");
      const response = await B2B_API.get(
        `pim/product/PIM-${pimId[pimId.length - 1]}`
      );
      const dataa = await response.json();
      const pimData = dataa.response;
      setPim(pimData || {});
      notify({
        error: false,
        success: true,
        title: "Notification sent successfully",
      });
    } catch (error) {
      notify({
        error: true,
        success: false,
        title: error?.message || "Something went wrong",
      });
    }
  };

  const sampleNotify = async () => {
    try {
      const res = await B2B_API.post(
        `sampleNotification/save?productId=${pim?.product?.productId}`
      );
      const data = await res.json();
      const pimId = pimUrl.split("-");
      const response = await B2B_API.get(
        `pim/product/PIM-${pimId[pimId.length - 1]}`
      );
      const dataa = await response.json();
      const pimData = dataa.response;
      setPim(pimData || {});
      notify({
        error: false,
        success: true,
        title: "Notification sent successfully",
      });
    } catch (error) {
      notify({
        error: true,
        success: false,
        title: error?.message || "Something went wrong",
      });
    }
  };

  const DisplayHierarchy = () => {
    return (
      <span className="item category">
        {categories?.length > 0 ? (
          categories.map((category, index) => {
            if (index === 0) return null;
            const isLast = index === categories.length - 1;
            return (
              <span key={index}>
                {isLast ? (
                  <a
                    swatchon-gtm="fabric_spec_category_link"
                    className="text-underline"
                  >
                    <span
                      onClick={() => handleScubaClick(category)}
                      style={{ cursor: "pointer" }}
                    >
                      {" "}
                      {category.name}
                    </span>
                  </a>
                ) : (
                  <span>{category.name}</span>
                )}
                {index < categories.length - 1 && <span> &gt; </span>}{" "}
              </span>
            );
          })
        ) : (
          <p>No hierarchy found.</p>
        )}
      </span>
    );
  };
  const handleSelectChange = (value) => {
    setSelectedValue(value);
    const filteredOption = _.filter(colorOption, (c) => c.id === value)[0];
    const skuCode = filteredOption ? filteredOption.skucode : null;
    setSelectedSku(skuCode);
  };
  const isNewArrival = () => {
    const createdDate = new Date(pim.createdDate);
    const currentDate = new Date();
    const diffTime = currentDate - createdDate;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    return diffDays <= 5;
  };

  const handleSwatchCard = async () => {
    const data = {
      pimId: pim.pimId,
      swatchId: pim.swatchId,
    };
    await B2B_API.post(`cart/swatch/save`, {
      json: data,
    });
    open();
    setItemAdded(true);
    existingCart();
    reloadHeader();
  };

  const leadTImeFunction = (item) => {
    const res11 = item?.sample
      ? pim?.pimOtherInformation?.sampleLeadTime
      : pim?.pimOtherInformation?.wholesaleLeadTime;
    return res11;
  };

  const calculateTotalQuantity = () => {
    // nothing selected → zero
    if (!Array.isArray(selectedValue) || selectedValue.length === 0) {
      return 0;
    }

    // map selected variant IDs → skucodes
    const selectedSkus = selectedValue
      .map((id) => colorOption.find((o) => o.value === id)?.skucode)
      .filter(Boolean);

    // if any selected sku is part of a combo, take the min wholeSaleQuantity
    const comboSelected = selectedSkus.some((sku) => combo?.includes(sku));
    if (comboSelected) {
      const minQty = combo
        .map((sku) => stock[sku]?.wholeSaleQuantity ?? 0)
        .reduce((min, q) => Math.min(min, q), Infinity);
      return minQty === Infinity ? 0 : minQty;
    }

    // otherwise sum each variant’s correct stock bucket
    return selectedValue.reduce((sum, id) => {
      const qtyEntered = minimumOrder[id] || 0;
      const opts = cartOptions[id] || {};
      const sku = colorOption.find((o) => o.value === id)?.skucode;
      if (!sku) return sum;

      // wholesale threshold?
      if (qtyEntered >= (opts.Wholesale ?? Infinity)) {
        return sum + (stock[sku]?.wholeSaleQuantity ?? 0);
      }
      // sample thresholds?
      if (
        qtyEntered >= (opts.SampleMin ?? 0) &&
        qtyEntered <= (opts.SampleMax ?? 0)
      ) {
        return sum + (stock[sku]?.quantity ?? 0);
      }
      // out‐of‐bounds
      return sum;
    }, 0);
  };

  return (
    <div className="view-quality-detail-v2 router-view-container">
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <Loader color={"var(--primary)"} type="oval" />
        </div>
      )}

      <div className="fixed-components"></div>
      <div className="width-limiter">
        <div className="quality-category">
          <span>All Fabrics</span>
          <span className="m-l-4 m-r-4">&gt;</span>
          <div className="t-fabric-spec">
            <DisplayHierarchy />
          </div>
        </div>
        <div
          className="upper"
          style={{ marginBottom: !ismobile && !isTab && "32px" }}
        >
          {ismobile || isTab ? (
            <div style={{ position: "relative" }}>
              <Carousel
                slideSize="100%"
                slideGap="md"
                align="center"
                loop={true}
                styles={{ slide: { overflow: "hidden" } }}
              >
                {slides}
              </Carousel>
              <div
                className="icon-overlay"
                style={{
                  position: "absolute",
                  top: "16px",
                  right: "16px",
                  pointerEvents: "auto",
                  zIndex: 10,
                }}
              >
                <ActionIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleWishlist(null, pim?.pimId, pim?.product?.articleName);
                  }}
                  aria-label="Toggle Wishlist"
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "9999px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backdropFilter: "blur(8px)",
                    WebkitBackdropFilter: "blur(8px)",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    border: "none",
                    backgroundColor: _.includes(pimVariantIds, pim?.pimId)
                      ? "#fee2e2"
                      : "rgba(255,255,255,0.9)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.1)";
                    e.currentTarget.style.backgroundColor = _.includes(pimVariantIds, pim?.pimId)
                      ? "#fecaca"
                      : "#ffffff";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.backgroundColor = _.includes(pimVariantIds, pim?.pimId)
                      ? "#fee2e2"
                      : "rgba(255,255,255,0.9)";
                  }}
                  onMouseDown={(e) => {
                    e.currentTarget.style.transform = "scale(0.95)";
                  }}
                  onMouseUp={(e) => {
                    e.currentTarget.style.transform = "scale(1.1)";
                  }}
                >
                  <IconHeart
                    style={{
                      width: "24px",
                      height: "24px",
                      transition: "all 0.3s ease",
                      color: _.includes(pimVariantIds, pim?.pimId)
                        ? "#ef4444"
                        : "#4b5563",
                      fill: _.includes(pimVariantIds, pim?.pimId)
                        ? "#f80b0b"
                        : "none",
                    }}
                  />
                </ActionIcon>
              </div>
            </div>
          ) : (
            <div className="quality-detail-medias wide">
              <div
                swatchon-gtm="item_media_view"
                className="thumbnail-container"
                style={{ position: "relative" }}
              >
                {renderMainContent()}
                <div
                  className="icon-overlay"
                  style={{
                    position: "absolute",
                    top: "16px",
                    right: "16px",
                    pointerEvents: "auto",
                    zIndex: 10,
                  }}
                >
                  <ActionIcon
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleWishlist(null, pim?.pimId, pim?.product?.articleName);
                    }}
                    aria-label="Toggle Wishlist"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "9999px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backdropFilter: "blur(8px)",
                      WebkitBackdropFilter: "blur(8px)",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      border: "none",
                      backgroundColor: _.includes(pimVariantIds, pim?.pimId)
                        ? "#fee2e2"
                        : "rgba(255,255,255,0.9)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.1)";
                      e.currentTarget.style.backgroundColor = _.includes(pimVariantIds, pim?.pimId)
                        ? "#fecaca"
                        : "#ffffff";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.backgroundColor = _.includes(pimVariantIds, pim?.pimId)
                        ? "#fee2e2"
                        : "rgba(255,255,255,0.9)";
                    }}
                    onMouseDown={(e) => {
                      e.currentTarget.style.transform = "scale(0.95)";
                    }}
                    onMouseUp={(e) => {
                      e.currentTarget.style.transform = "scale(1.1)";
                    }}
                  >
                    <IconHeart
                      style={{
                        width: "24px",
                        height: "24px",
                        transition: "all 0.3s ease",
                        color: _.includes(pimVariantIds, pim?.pimId)
                          ? "#ef4444"
                          : "#4b5563",
                        fill: _.includes(pimVariantIds, pim?.pimId)
                          ? "#f80b0b"
                          : "none",
                      }}
                    />
                  </ActionIcon>
                </div>
              </div>
              <div className="app-carousel m-t-8">
                {showScrollLeft && (
                  <div className="handle left m-r-4">
                    <FontAwesomeIcon
                      className="i far"
                      icon={faChevronLeft}
                      onClick={scrollLeft}
                    />
                  </div>
                )}
                <div
                  className="carousel-children-layout no-scrollbar"
                  ref={scrollContainerRef}
                  onScroll={handleScroll}
                >
                  {media.map((m, indx) => (
                    <div
                      key={m.id || indx}
                      className="carousel-item selected"
                      style={{
                        minWidth: "calc(14.2857% - 9.71429px)",
                        maxWidth: "calc(14.2857% - 9.71429px)",
                        marginRight: "8px",
                      }}
                    >
                      <div
                        className="carousel-image"
                        onClick={() => setMainContent(m)}
                        style={{ position: "relative" }}
                      >
                        {m.type === "video" ? (
                          <>
                            <div className="video-wrapper">
                              <video
                                src={`${m.src}`}
                                className="app-img cover"
                                muted
                                loop
                                playsInline
                                preload="auto"
                                onMouseEnter={(e) => {
                                  e.target.muted = true;
                                  e.target.play().catch(() => { });
                                }}
                                onMouseLeave={(e) => {
                                  e.target.pause();
                                  e.target.currentTime = 0;
                                }}
                                style={{
                                  border:
                                    mainContent?.src === m?.src ? "3px solid #8BC53F" : "none",
                                  borderRadius: "5px",
                                  display: "block",
                                }}
                              />

                              <div className="play-buttonnplay">
                                <FontAwesomeIcon icon={faCirclePlay} />
                              </div>
                            </div>
                          </>
                        ) : (
                          <img
                            className="app-img cover overlay"
                            src={`${m.src}`}
                            alt="product"
                            loading="eager"

                            draggable="false"
                            style={{
                              border:
                                mainContent?.src === m?.src ? "3px solid #8BC53F" : "none",
                              borderRadius: "5px",
                            }}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </div>

                {showScrollRight && (
                  <div className="handle right m-l-4">
                    <FontAwesomeIcon
                      className="i far"
                      icon={faChevronRight}
                      onClick={scrollRight}
                    />
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="info-and-products" style={{ marginBottom: "1.7rem" }}>
            <div className="quality-detail-summary building-block">
              {isNewArrival() && (
                <div className="badge-new-arrivals flex-wrap" >NEW</div>
              )}
              <div className="flex-row items-center g-16">

                <div
                  swatchon-gtm="view_item_ql_code"
                  className="ql-code flex-wrap"
                >
                  <span>{pim?.product?.articleCode}</span>
                </div>
              </div>
              <div className="f-18 f-600 m-t-4 m-b-12" style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexWrap: "wrap",
              }}>
                {pim?.product?.articleName}
                {(pim?.product?.vendorReadyStock ||
                  pim?.product?.readyStock ||
                  pim?.product?.orderDriven) && (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "4px 10px",
                        borderRadius: "20px",
                        letterSpacing: "1px",
                        fontSize: "10px",
                        fontWeight: 900,
                        color: "#fff",
                        backgroundColor: "#ff6b00",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {pim?.product?.vendorReadyStock
                        ? "VENDOR STOCK"
                        : pim?.product?.readyStock
                          ? "READY STOCK"
                          : pim?.product?.orderDriven
                            ? "MADE TO ORDER"
                            : ""}
                    </span>
                  )}
              </div>

              <div className="spec-badges">
                <div className="spec-badge">
                  {" "}
                  {categories?.length > 0 ? (
                    categories.map((category, index) => {
                      if (index === 0) return null;
                      return (
                        <span key={index}>
                          <span>{category.name}</span>
                          {index < categories.length - 1 && (
                            <span> &gt; </span>
                          )}{" "}
                        </span>
                      );
                    })
                  ) : (
                    <p>No hierarchy found.</p>
                  )}
                </div>
                <div className="spec-badge">
                  {pim?.product?.fabricContent?.value} %
                </div>
                <div className="spec-badge">
                  {pim?.product?.metrics?.weight} gsm
                </div>
                <div className="spec-badge">{colorVariantsCount} Colors</div>
                <div
                  className="text-underline f-500 c-gray-600 cursor-pointer view-full-spec-button"
                  onClick={scrollToFabricSpecs}
                >
                  {" "}
                  View Full Spec{" "}
                </div>
              </div>
              <div className="flex g-16 m-t-16">
                <div className="summary-row">
                  <div className="key">Seller</div>
                  <div className="value"  style={{display:"flex"}}>
                    <Link
                      to="/fabrics"
                      state={{
                        vendorFilter: {
                          vendorId: pim?.vendorId,
                          pims: pim,
                        },
                        pagee: 0
                      }}
                      className="c-gray-600 text-underline flex-wrap"
                    >
                      {pim?.vendorName}
                    </Link>
                  </div>
                </div>
                <div className="quality-detail-prices">
                  <div className="summary-row">
                    <div className="key">Pricing</div>
                    <div className="value"  style={{display:"flex"}}>
                      <div className="price-info-wrapper flex-row items-center g-8">
                        <div className="price-info f-18 f-700 flex-wrap">
                          {/* {pim.minPrice ?  */}

                          {allMinPrice && allMaxPrice ? <>
                            &#8377; {_.round(allMinPrice, 2)} - &#8377;{" "}
                            {_.round(allMaxPrice, 2)}
                            {isKg === true ? (
                              <small>/kgs</small>
                            ) : isMeter === true ? (
                              <small>/m</small>
                            ) : isYard === true ? (
                              <small>/yrd</small>
                            ) : (
                              "-"
                            )}
                          </> :
                            <>
                              &#8377; {pim.product?.priceSetting?.sellingPrice}
                              {isKg === true ? (
                                <small>/kgs</small>
                              ) : isMeter === true ? (
                                <small>/m</small>
                              ) : isYard === true ? (
                                <small>/yrd</small>
                              ) : (
                                "-"
                              )}
                            </>
                          }

                          {/* // : (
                          //   <>
                          //     {pim.product?.priceSetting?.sellingPrice}
                          //     {isKg === true ? (
                          //       <small>/kgs</small>
                          //     ) : isMeter === true ? (
                          //       <small>/m</small>
                          //     ) : isYard === true ? (
                          //       <small>/yrd</small>
                          //     ) : (
                          //       "-"
                          //     )}
                          //   </>
                          // ) */}
                        </div>
                        <span
                          className="underlined-function f-500"
                          onClick={scrollToPriceRef}
                        >
                          {" "}
                          View Pricing Table{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="quality-detail-purchase-info g-8">
                  <div className="summary-row">
                    <div className="key">MOQ</div>
                    <div className="value flex g-4">
                      <div className="moq-row g-16">
                        <span className="moq-key">Sample</span>
                        <span className="f-15 f-600">
                          {cartOptions[selectedValue]?.SampleMin} -{" "}
                          {cartOptions[selectedValue]?.SampleMax}
                          {isKg === true ? (
                            <small> kg</small>
                          ) : isMeter === true ? (
                            <small> meter</small>
                          ) : isYard === true ? (
                            <small> yard</small>
                          ) : (
                            "-"
                          )}
                        </span>
                      </div>
                      <div className="moq-row g-16">
                        <span className="moq-key">Wholesale Stock</span>
                        <span className="f-15 f-600">
                          {cartOptions[selectedValue]?.Wholesale}
                          {isKg === true ? (
                            <small> kg</small>
                          ) : isMeter === true ? (
                            <small> meter</small>
                          ) : isYard === true ? (
                            <small> yard</small>
                          ) : (
                            "-"
                          )}
                        </span>
                      </div>

                      <div
                        className="underlined-function f-500"
                        onClick={scrollToMoqRef}
                      >
                        View MOQ Table
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>

            <br />
            <div className="building-block">
              <Tabs
                value={selectedOrderType}
                onChange={(value) => {
                  setSelectedOrderType(value);
                  setCurrIdOfSelected(null);
                }}
                variant="default"
              >
                <Tabs.List style={{ width: "100%" }}>
                  <Tabs.Tab
                    className="f-600"
                    style={{ flex: 1 }}
                    value="WHOLESALE"
                  >
                    Wholesale
                  </Tabs.Tab>
                  <Tabs.Tab
                    className="f-600"
                    style={{ flex: 1 }}
                    value="SAMPLE"
                  >
                    Sample
                  </Tabs.Tab>
                  <Tabs.Tab
                    className="f-600"
                    style={{ flex: 1 }}
                    value="SWATCH"
                  >
                    Swatch
                  </Tabs.Tab>
                </Tabs.List>
              </Tabs>
              <br />
              <div className="quality-product-payload">
                <div
                  className="cart-product-payload-item"
                  style={{ display: "none" }}
                >
                  <div className="row">
                    <div className="field-name">Type</div>
                    <div className="flex-fill">
                      <div className="fake-dropdown">
                        <div className="selected-option">
                          <div className="flex-fill lines-1">
                            Standard Colors{" "}
                          </div>
                          <FontAwesomeIcon
                            className="far f-10"
                            icon={faChevronDown}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {selectedOrderType !== "SWATCH" &&
                  reorderedOptions.length > 0 && (
                    <Carousel
                      className="variant-carousel"
                      slideSize={ismobile ? "50%" : "35.333%"}
                      align="start"
                      slideGap="sm"
                      slidesToScroll={ismobile ? 1 : 2}
                      initialSlide={0} // because now the selected one is first
                      draggable={false}
                      withControls

                    >
                      {reorderedOptions.length > 0 &&
                        reorderedOptions.map((option, index) => {
                          console.log(option,"mkiu")
                          const isInCombo = combo?.includes(option.skucode);
                          const isInCartSample =
                            alreadyInCart[option.id]?.sample;
                          const isInCartWholeSale =
                            alreadyInCart[option.id]?.wholeSale;
                          const isInCartCombo = alreadyInCart[option.id]?.combo;
                          const isDisabled =
                            profile?.approveStatus !== "APPROVED" ||
                            isInCartSample ||
                            isInCartWholeSale ||
                            isInCombo;
                          if (
                            (selectedOrderType !== "WHOLESALE" && !option.sample)
                          ) {
                            return;
                          }
                          const comboBatchInWholesale =
                            isInCombo &&
                            combo.some((sku) => {
                              const o = filteredOptions.find(
                                (o) => o.skucode === sku
                              );
                              return o && alreadyInCart[o.id]?.combo;
                            });

                          let badgeText = "";
                          let comboText = "";
                          if (isInCombo && comboBatchInWholesale) {
                            badgeText = "In Wholesale cart";
                          }
                          if (
                            isInCartSample &&
                            selectedOrderType === "SAMPLE"
                          ) {
                            badgeText = "In Sample cart";
                          }
                          if (
                            isInCartWholeSale &&
                            selectedOrderType === "WHOLESALE"
                          ) {
                            badgeText = "In Wholesale cart";
                          }
                          if (isInCombo) {
                            comboText = "Combo";
                          }

                          const kgPerRoll = kgPerRollByVariant[option.id] || 20;
                          const currentKg = variantOrders[option.id]?.kg || 0;
                          const { roll = "", kg = "" } = variantOrders[option.id] || {};
                          const hasVariant = (variantOrders[option.id]?.kg || 0) > 0;
                          const ribEnabled = bundle?.mandatory === false && !hasVariant;
                          const minWholesale =
                            cartOptions[option.id]?.SampleMin || 1;
                          const maxWholesale =
                            cartOptions[option.id]?.SampleMax || 1;
                          const hasbunle = bundle?.bundleVariants?.find((variant) => variant.fabricPimVariantSku === option.skucode)
                          const bundleData = bundle?.ribsPim?.pimVariants.find((v) => v?.variantSku === hasbunle?.ribPimVariantSku)
                          const isChecked = selectedValues.includes(option.id);
                          let comboHasZeroQty = false;
                          let qtyAvailable = 0;
                          if (selectedOrderType === "SAMPLE") {
                            qtyAvailable =
                              Math.round(
                                stock[option?.skucode]?.sampleQuantity
                              ) ?? 0;
                          }
                          //  else {
                          //   if (isInCombo) {
                          //     const allQs = combo.map(
                          //       (groupSku) =>
                          //         stock[groupSku]?.wholeSaleQuantity ?? 0
                          //     );
                          //     comboHasZeroQty = allQs.some(qty => qty === 0);

                          //     qtyAvailable = allQs.length
                          //       ? Math.min(...allQs)
                          //       : 0;
                          //   } 
                          else {
                            qtyAvailable =
                              stock[option?.skucode]?.wholeSaleQuantity ?? 0;
                          }

                          return (

                            <Carousel.Slide key={option.id}>
                              <div className="variant-card">
                                <div>


                                  <div style={{ marginTop: "0px" }}>

                                  </div>


                                  <div className="image-wrapperr" >
                                    <img
                                      className="app-imgg"
                                      src={`${BASE_URL}${option.image?.replace("/api", "")}?time=${Date.now()}`}
                                      onClick={() => {
                                        setSelectedImageTop(option);
                                        setImageIndex(index);
                                      }}
                                      alt="Product"

                                    />

                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "8px",
                                        right: "8px",
                                      }}
                                    >
                                      <button
                                        onClick={() => toggleWishlist(option?.id, null, option?.color)}
                                        style={{
                                          width: "32px",
                                          height: "32px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "9999px",
                                          backdropFilter: "blur(8px)",
                                          WebkitBackdropFilter: "blur(8px)",
                                          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                                          transition: "all 0.3s ease",
                                          cursor: "pointer",
                                          border: "none",
                                          backgroundColor: _.includes(pimVariantIds, option?.id)
                                            ? "#fee2e2" // red-100
                                            : "rgba(255,255,255,0.8)",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.transform = "scale(1.1)";
                                          e.currentTarget.style.backgroundColor = _.includes(pimVariantIds, option?.id)
                                            ? "#fecaca" // red-200
                                            : "#ffffff";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.transform = "scale(1)";
                                          e.currentTarget.style.backgroundColor = _.includes(pimVariantIds, option?.id)
                                            ? "#fee2e2"
                                            : "rgba(255,255,255,0.8)";
                                        }}
                                        onMouseDown={(e) => {
                                          e.currentTarget.style.transform = "scale(0.95)";
                                        }}
                                        onMouseUp={(e) => {
                                          e.currentTarget.style.transform = "scale(1.1)";
                                        }}
                                      >
                                        <IconHeart
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                            transition: "all 0.3s ease",
                                            color: _.includes(pimVariantIds, option?.id)
                                              ? "#ef4444" // red-500
                                              : "#4b5563", // gray-600
                                            fill: _.includes(pimVariantIds, option?.id)
                                              ? "#f80b0b"
                                              : "none",
                                          }}
                                        />
                                      </button>
                                    </div>
                                    <div className="badge-sample-dark-overlay" >
                                      {badgeText}
                                    </div>
                                  </div>


                                  <div
                                    className="badges"
                                    style={{
                                      alignItems: "center",
                                      justifyContent: "center",
                                      display: "flex",
                                      marginTop: "5px",
                                    }}
                                  ></div>
                                  <div className="combo-color" >
                                    <div>
                                      <span>
                                        <ColorSwatch
                                          color={option.code}
                                          size={"0.8rem"}
                                          style={{ marginTop: "0.3rem" }}
                                        />
                                      </span>
                                    </div>
                                    <div className="badges">
                                      <div className="badge-sample-dark-combo">
                                        {selectedOrderType !== "SAMPLE" && comboText}
                                      </div>
                                    </div></div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      marginBottom: "0.5rem",
                                      marginLeft: "0.5rem",
                                    }}
                                  >
                                    <span>
                                     <span title={option.color} style={{ fontWeight: "bold" }}>
                                        #{`${index + 1}.${option.color && option.color.length > 10 ? option.color.substring(0, 10) + '...' : option.color}`}
                                      </span>
                                    </span>
                                    {(qtyAvailable > 0 && !(isInCombo && comboHasZeroQty)) ? (
                                      <span style={{ color: "green" }}>
                                        Available Qty : {qtyAvailable.toFixed(2)}    {(
                                          <span>
                                            {isKg
                                              ? kg === 1
                                                ? "kg"
                                                : "kgs"
                                              : isMeter
                                                ? kg === 1
                                                  ? "mtr"
                                                  : "mtrs"
                                                : isYard
                                                  ? kg === 1
                                                    ? "yrd"
                                                    : "yrds"
                                                  : ""}
                                          </span>
                                        )}
                                      </span>
                                    ) : (<span style={{ color: "red" }}>Lead time :
                                      {leadTImeFunction(option)
                                        ? ` ${leadTImeFunction(option)}`
                                        : " - "} days
                                    </span>

                                    )}
                                  </div>
                                </div>
                                <div className="roll-kg-inputs">
                                  {selectedOrderType === "WHOLESALE" && (
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "1rem",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "0.2rem",
                                          alignItems: "center",
                                          marginLeft: "0.5rem",
                                        }}
                                      >
                                        <ActionIcon
                                          size={20}
                                          variant="light"
                                          style={{
                                            width: 20,
                                            height: 20,
                                            color: "black",
                                            backgroundColor: "transparent",
                                          }}
                                          onClick={() => {
                                            const affectedIds =
                                              getAffectedIds(option.id);
                                            const firstId = affectedIds[0];
                                            const oldRoll = variantOrders[firstId]?.roll || 0;
                                            const newRoll = oldRoll - 1;
                                            const newKg = newRoll * kgPerRoll;

                                            setVariantOrders((prev) => {
                                              const updated = { ...prev };
                                              affectedIds.forEach((id) => {
                                                const oldRoll =
                                                  prev[id]?.roll || 0;
                                                const newRoll = Math.max(
                                                  0,
                                                  oldRoll - 1
                                                );
                                                const newKg =
                                                  newRoll * kgPerRoll;

                                                if (newRoll === 0) {
                                                  delete updated[id];
                                                } else {
                                                  updated[id] = {
                                                    roll: newRoll,
                                                    kg: newKg,
                                                  };
                                                }
                                              });

                                              return updated;
                                            });
                                            const ribAffectedIds = getAffectedRibIds(option.id);
                                            if (ribOrders?.[option?.id]) {
                                              setRibOrders((prev) => {
                                                const updated = { ...prev };
                                                ribAffectedIds.forEach((id) => {
                                                  const ribskg = isMeter
                                                    ? Math.ceil((newKg * meterToKgFactor * bundle.ratio) / 100)
                                                    : Math.ceil((newKg * bundle.ratio) / 100);

                                                  if (ribskg === 0) {
                                                    delete updated[id];
                                                  } else {
                                                    updated[id] = { value: ribskg, kg: newKg };
                                                  }
                                                });
                                                return updated;
                                              });
                                            }

                                            setTimeout(() => {
                                              const newRollForFirst =
                                                variantOrders[option.id]
                                                  ?.roll || 0;
                                              if (newRollForFirst === 0) {
                                                const affectedIds =
                                                  getAffectedIds(option.id);
                                                removeFromSelected(
                                                  affectedIds
                                                );
                                              }
                                            }, 0);
                                          }}
                                        >
                                          <IconMinus size={18} />
                                        </ActionIcon>

                                        <Input
                                          value={variantOrders[option.id]?.roll || 0}
                                          placeholder="0"
                                          style={{
                                            width: 70,
                                            height: 40,
                                            textAlign: "center",
                                          }}
                                          onChange={(evt) => {
                                            const str = evt.currentTarget.value;

                                            // Allow only digits and empty string
                                            if (!/^\d*$/.test(str)) return;

                                            // Treat empty string as 0
                                            const parsed = str === "" ? 0 : parseInt(str, 10);

                                            const affectedIds = getAffectedIds(option.id);
                                            const newKg = parsed * kgPerRoll;

                                            setVariantOrders((prev) => {
                                              const updated = { ...prev };
                                              affectedIds.forEach((id) => {
                                                updated[id] = {
                                                  roll: parsed,
                                                  kg: newKg,
                                                };
                                              });
                                              return updated;
                                            });

                                            setRibOrders((prev) => {
                                              const updated = { ...prev };
                                              affectedIds.forEach((id) => {
                                                const ribskg = isMeter
                                                  ? ((newKg * meterToKgFactor * bundle?.ratio) / 100)
                                                  : ((newKg * bundle?.ratio) / 100);

                                                if (ribskg === 0) {
                                                  delete updated[id];
                                                } else {
                                                  updated[id] = { value: ribskg, kg: newKg };
                                                }
                                              });
                                              return updated;
                                            });

                                            if (parsed > 0) {
                                              addToSelected(affectedIds);
                                            } else {
                                              removeFromSelected(affectedIds);
                                            }
                                          }}
                                        />


                                        <ActionIcon
                                          size={20}
                                          variant="light"
                                          style={{
                                            width: 20,
                                            height: 20,
                                            color: "black",
                                            backgroundColor: "transparent",
                                          }}
                                          onClick={() => {
                                            const affectedIds = getAffectedIds(option.id);
                                            const firstId = affectedIds[0];
                                            const oldRoll = variantOrders[firstId]?.roll || 0;
                                            const newRoll = oldRoll + 1;
                                            const newKg = newRoll * kgPerRoll;

                                            setVariantOrders((prev) => {
                                              const updated = { ...prev };
                                              affectedIds.forEach((id) => {
                                                updated[id] = {
                                                  roll: newRoll,
                                                  kg: newKg,
                                                };
                                              });
                                              return updated;
                                            });

                                            const ribAffectedIds = getAffectedRibIds(option.id);
                                            if (ribOrders?.[option?.id]) {
                                              setRibOrders((prev) => {
                                                const updated = { ...prev };
                                                ribAffectedIds.forEach((id) => {
                                                  const ribskg = isMeter
                                                    ? Math.ceil((newKg * meterToKgFactor * bundle.ratio) / 100)
                                                    : Math.ceil((newKg * bundle.ratio) / 100);

                                                  if (ribskg === 0) {
                                                    delete updated[id];
                                                  } else {
                                                    updated[id] = { value: ribskg, kg: newKg };
                                                  }
                                                });
                                                return updated;
                                              });
                                            }
                                            addToSelected(ribAffectedIds);
                                          }}
                                        >
                                          <IconPlus size={18} />
                                        </ActionIcon>


                                        {roll >= 1 && (
                                          <span>
                                            {roll === 1 ? "Roll" : "Rolls"}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  <div>
                                    {selectedOrderType === "SAMPLE" ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "1rem",
                                          alignItems: "center",
                                          marginLeft: "0.5rem",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "0.2rem",
                                            alignItems: "center",
                                          }}
                                        >

                                          <ActionIcon
                                            size={20}
                                            variant="light"
                                            disabled={isInCartSample}
                                            style={{
                                              width: 20,
                                              height: 20,
                                              color: "black",
                                              backgroundColor: "transparent",
                                            }}
                                            onClick={() => {
                                              const affectedIds = getAffectedIds(option.id);

                                              setVariantOrders((prev) => {
                                                const updated = { ...prev };

                                                affectedIds.forEach((id) => {
                                                  const oldKg = prev[id]?.kg || 0;

                                                  const newKg = oldKg <= minWholesale ? 0 : oldKg - 1;
                                                  const newRoll = newKg > 0 ? Math.ceil(newKg / kgPerRoll) : 0;

                                                  if (newKg === 0) {
                                                    delete updated[id];
                                                  } else {
                                                    updated[id] = { roll: newRoll, kg: newKg };
                                                  }
                                                });

                                                return updated;
                                              });

                                              addToSelected(affectedIds);
                                            }}
                                          >
                                            <IconMinus size={18} />
                                          </ActionIcon>
                                          <Input
                                            value={variantOrders[option.id]?.kg || 0}
                                            placeholder="0"
                                            style={{
                                              width: 70,
                                              height: 40,
                                              textAlign: "center",
                                            }}
                                            disabled={isInCartSample}
                                            onChange={(evt) => {
                                              const str = evt.currentTarget.value;

                                              if (!/^\d*$/.test(str)) return;

                                              let parsedKg = str === "" ? 0 : parseInt(str, 10);

                                              const minWholesale = cartOptions[option.id]?.SampleMin || 1;
                                              const maxWholesale = cartOptions[option.id]?.SampleMax || 1;

                                              if (parsedKg > maxWholesale) {
                                                parsedKg = maxWholesale;
                                              }

                                              const affectedIds = getAffectedIds(option.id);
                                              const newRoll = parsedKg > 0 ? Math.ceil(parsedKg / kgPerRoll) : 0;

                                              setVariantOrders((prev) => {
                                                const updated = { ...prev };
                                                affectedIds.forEach((id) => {
                                                  if (parsedKg <= 0) {
                                                    delete updated[id];
                                                  } else {
                                                    updated[id] = {
                                                      roll: newRoll,
                                                      kg: parsedKg,
                                                    };
                                                  }
                                                });
                                                return updated;
                                              });

                                              if (parsedKg > 0) {
                                                addToSelected(affectedIds);
                                              } else {
                                                removeFromSelected(affectedIds);
                                              }
                                            }}
                                          />

                                          <ActionIcon
                                            size={20}
                                            variant="light"
                                            disabled={isInCartSample || currentKg >= maxWholesale}
                                            style={{
                                              width: 20,
                                              height: 20,
                                              color: "black",
                                              backgroundColor: "transparent",
                                            }}
                                            onClick={() => {
                                              const affectedIds = getAffectedIds(option.id);
                                              setVariantOrders((prev) => {
                                                const updated = { ...prev };

                                                affectedIds.forEach((id) => {
                                                  const oldKg = prev[id]?.kg || 0;

                                                  const newKg = oldKg < minWholesale ? minWholesale : oldKg + 1;
                                                  const newRoll = Math.ceil(newKg / kgPerRoll);

                                                  updated[id] = { roll: newRoll, kg: newKg };
                                                });

                                                return updated;
                                              });

                                              addToSelected(affectedIds);
                                            }}
                                          >
                                            <IconPlus size={18} />
                                          </ActionIcon>
                                          {kg > 0 && (
                                            <span>
                                              {isKg
                                                ? kg === 1
                                                  ? "kg"
                                                  : "kgs"
                                                : isMeter
                                                  ? kg === 1
                                                    ? "mtr"
                                                    : "mtrs"
                                                  : isYard
                                                    ? kg === 1
                                                      ? "yrd"
                                                      : "yrds"
                                                    : ""}
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    ) : (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "0.2rem",
                                          marginLeft: "0.5rem",
                                          marginBottom: "1rem",
                                        }}
                                      >
                                        <div style={{ width: "70%" }}>
                                          <Input
                                            placeholder={
                                              isKg === true
                                                ? "KG"
                                                : isMeter === true
                                                  ? "METER"
                                                  : isYard === true
                                                    ? "YARD"
                                                    : "-"
                                            }
                                            required
                                            type="number"
                                            readOnly
                                            value={kg}
                                            className="disabled-input"
                                          />
                                        </div>
                                        {kg ? (
                                          <span style={{ display: "flex", alignItems: "center" }}>
                                            {" "}
                                            {isKg === true ? (
                                              <span>
                                                {" "}
                                                {isKg > 0 ? "kgs" : "kg"}
                                              </span>
                                            ) : isMeter === true ? (
                                              <span>
                                                {isMeter > 0 ? "mtrs" : "mtr"}
                                              </span>
                                            ) : isYard === true ? (
                                              <span>
                                                {isYard > 0 ? "yrds" : "yrd"}
                                              </span>
                                            ) : (
                                              "-"
                                            )}
                                          </span>
                                        ) : (
                                          ""
                                        )}

                                      </div>

                                    )}
                                    <div>

                                    </div>
                                  </div>
                                  {selectedOrderType !== "WHOLESALE" &&
                                    // minWholesale &&
                                    // (kg < minWholesale ||
                                    //   kg > maxWholesale) && (
                                    (
                                      <small
                                        style={{
                                          color: "gray",
                                          display: "block",
                                          marginTop: "0.5rem",
                                          marginLeft: "0.5rem",
                                          marginBottom: "0.5rem",
                                        }}
                                      >
                                        <span style={{ fontWeight: "bold", color: "red" }}>
                                          Note :
                                        </span>{" "}
                                        Min{" "}
                                        {minWholesale}{" "}{isKg
                                          ? "kg"
                                          : isMeter
                                            ? "m"
                                            : isYard
                                              ? "yard"
                                              : ""} - Max {maxWholesale}{" "}
                                        {isKg
                                          ? "kg"
                                          : isMeter
                                            ? "m"
                                            : isYard
                                              ? "yard"
                                              : ""}
                                        .
                                      </small>

                                    )}

                                </div>
                              </div>

                              {hasbunle && selectedOrderType === "WHOLESALE" && <div className="dropdown-container">
                                <div className="dropdown-card-rib">
                                  <div className="rib-info">
                                    <div className="Rib-avai-top" style={{ marginLeft: "0.1rem" }}>
                                      <div className="Rib-avai" style={{ fontWeight: "bold", color: "white" }}>RIB</div>
                                      <div className="Rib-Pim" style={{ fontWeight: "bold" }}> {bundleData?.name.split("/")[0]} </div>
                                    </div>
                                      <span title={bundleData?.name.split("/")[2]} style={{ fontWeight: "bold" }}>
                                        #{`${index + 1}.${bundleData?.name.split("/")[2] && bundleData?.name.split("/")[2].length > 10 ? bundleData?.name.split("/")[2].substring(0, 10) + '...' : bundleData?.name.split("/")[2]}`}
                                      </span>
                                    {bundle?.mandatory === false && (<div className="rib-Note" style={{ color: "gray", fontSize: "12px", fontWeight: "bold" }}>Note : <span className="rib-Note-qty" style={{ fontSize: "12px", color: "red", fontWeight: "lighter" }}>Max Qty {isMeter
                                      ? Math.ceil((kg / meterToKgFactor * bundle?.ratio) / 100)
                                      : Math.ceil((kg * bundle?.ratio) / 100)}</span></div>)}
                                    <div className="rib-split" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                      <div className="rib-cal-input">
                                        {selectedOrderType === "WHOLESALE" && (
                                          <div style={{ display: "flex", gap: "1rem", alignItems: "center", marginTop: "0.3rem" }}>
                                            <div style={{ display: "flex", gap: "0.2rem", alignItems: "center" }}>
                                              <ActionIcon
                                                size={20}
                                                variant="light"
                                                disabled={bundle?.mandatory === true || bundle?.mandatory === false && kg < 1}
                                                style={{ width: 20, height: 20, color: "black", backgroundColor: "transparent" }}
                                                onClick={() => {
                                                  const affectedIds = getAffectedRibIds(option.id);
                                                  const firstId = affectedIds[0];
                                                  const ratio = Number(bundle?.ratio) || 0;
                                                  const factor = Number(meterToKgFactor) || 1;


                                                  const maxAllowedKg = isMeter
                                                    ? Math.ceil((kg * factor * ratio) / 100)
                                                    : Math.ceil((kg * ratio) / 100);

                                                  setRibOrders((prev) => {
                                                    const updated = { ...prev };

                                                    affectedIds.forEach((id) => {
                                                      const oldVal = prev[id]?.value || 0;
                                                      const newVal = Math.max(0, oldVal - maxAllowedKg);

                                                      const ratio = Number(bundle?.ratio) || 0;
                                                      const factor = Number(meterToKgFactor) || 1;
                                                      const newKg = isKg && ratio > 0
                                                        ? isMeter
                                                          ? ((newVal * factor) * ratio) / 100
                                                          : (newVal * ratio) / 100
                                                        : 0;

                                                      if (newVal === 0) {
                                                        delete updated[id];
                                                      } else {
                                                        updated[id] = { value: newVal, kg: newKg };
                                                      }
                                                    });

                                                    return updated;
                                                  });

                                                  setTimeout(() => {
                                                    if ((ribOrders[firstId]?.value || 0) === 0) {
                                                      removeFromSelectedRibs(affectedIds);
                                                    }
                                                  }, 0);
                                                }}
                                              >
                                                <IconMinus size={16} />
                                              </ActionIcon>

                                              {bundle?.mandatory === false ? (
                                                <Input
                                                  value={(ribOrders[getAffectedRibIds(option.id)[0]]?.value) || 0}
                                                  placeholder="0"
                                                  readOnly
                                                  style={{ width: 70, height: 40, textAlign: "center" }}

                                                />

                                              ) : (() => {
                                                const affectedIds = getAffectedRibIds(option.id);
                                                const kgg = variantOrders[option.id]?.kg || 0;
                                                const ratio = Number(bundle?.ratio) || 0;
                                                const factor = Number(meterToKgFactor) || 1;

                                                if (!ratio || !kg) {
                                                  return (
                                                    <Input
                                                      value={0}
                                                      readOnly
                                                      placeholder="0"
                                                      style={{
                                                        width: 70,
                                                        height: 40,
                                                        textAlign: "center",
                                                      }}
                                                    />
                                                  );
                                                }
                                                let newKg = 0;


                                                newKg = isMeter
                                                  ? ((kgg / factor) * ratio / 100)
                                                  : (kgg * ratio) / 100;

                                                const kggg = Math.ceil(newKg);
                                                const cal = isMeter
                                                  ? Math.ceil((kg / factor) * (100 / ratio))
                                                  : Math.ceil((kg * 100) / ratio);
                                                if (
                                                  !ribOrders[affectedIds[0]] ||
                                                  ribOrders[affectedIds[0]]?.kg !== cal
                                                ) {
                                                  const updated = { ...ribOrders };
                                                  affectedIds.forEach((id) => {
                                                    updated[id] = {
                                                      value: kggg,
                                                      kg: cal
                                                    };
                                                  });

                                                  setRibOrders(updated);
                                                  addToSelectedRibs(affectedIds);
                                                }

                                                return (
                                                  <Input
                                                    value={kggg}
                                                    readOnly
                                                    placeholder="0"
                                                    style={{
                                                      width: 70,
                                                      height: 40,
                                                      textAlign: "center",
                                                    }}
                                                  />
                                                );
                                              })()}

                                              <ActionIcon
                                                size={20}
                                                variant="light"
                                                disabled={bundle?.mandatory === true || bundle?.mandatory === false && kg < 1}
                                                style={{ width: 20, height: 20, color: "black", backgroundColor: "transparent" }}
                                                onClick={() => {
                                                  const affectedIds = getAffectedRibIds(option.id);

                                                  const ratio = Number(bundle?.ratio) || 0;
                                                  const factor = Number(meterToKgFactor) || 1;
                                                  const maxAllowedKg = isMeter
                                                    ? Math.ceil((kg * factor * ratio) / 100)
                                                    : Math.ceil((kg * ratio) / 100);
                                                  setRibOrders((prev) => {
                                                    const updated = { ...prev };

                                                    const currentVal = prev[affectedIds[0]]?.value || 0;
                                                    const nextVal = maxAllowedKg;

                                                    const nextKg = isMeter
                                                      ? ((nextVal * factor * ratio) / 100)
                                                      : ((nextVal * ratio) / 100);
                                                    if (nextVal > maxAllowedKg) {

                                                      return prev;
                                                    }

                                                    affectedIds.forEach((id) => {
                                                      updated[id] = { value: nextVal, kg: nextKg };
                                                    });

                                                    return updated;
                                                  });

                                                  addToSelectedRibs(affectedIds);
                                                }}
                                              >
                                                <IconPlus size={16} />
                                              </ActionIcon>

                                              kgs
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                              }
                            </Carousel.Slide>
                          );
                        })}
                    </Carousel>
                  )}
                <div className="total-details"

                >
                  {selectedOrderType === "WHOLESALE" &&
                    filteredOptions.length > 0 && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.2rem",
                        }}
                      >
                        <Input
                          type="number"
                          readOnly
                          style={{ width: "100px" }}
                          className="disabled-input"
                          value={Object.values(variantOrders).reduce(
                            (sum, curr) => sum + (parseInt(curr.roll) || 0),
                            0
                          )}
                        />
                        <strong> Total Rolls</strong>
                      </div>
                    )}

                  {selectedOrderType !== "SWATCH" &&
                    filteredOptions.length > 0 && (
                      <>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.2rem",
                          }}
                        >
                          <Input
                            type="number"
                            readOnly
                            style={{ width: "100px" }}
                            className="disabled-input"
                            value={Object.values(variantOrders).reduce(
                              (sum, curr) => sum + (parseInt(curr.kg) || 0),
                              0
                            )}
                          />
                          <strong >
                            Total{" "}
                            {isKg === true ? (
                              <strong>Kgs</strong>
                            ) : isMeter === true ? (
                              <strong>Meters</strong>
                            ) : isYard === true ? (
                              <strong>Yards</strong>
                            ) : (
                              "-"
                            )}
                          </strong></div>
                      </>
                    )}

                  {selectedOrderType === "WHOLESALE" &&
                    filteredOptions.length > 0 && bundle && (
                      <>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.2rem",
                          }}
                        >
                          <Input
                            type="number"
                            readOnly
                            style={{ width: "100px" }}
                            className="disabled-input"
                            value={Object.values(ribOrders).reduce((sum, curr) => {
                              const safeCurr = Number(curr?.value) || 0;
                              return sum + safeCurr;
                            }, 0)}
                          />

                          <strong >
                            Total Rib kgs

                          </strong></div>
                      </>
                    )}
                  {/* {selectedOrderType === "WHOLESALE" &&
                    filteredOptions.length > 0 && (
                      <>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.2rem",
                          }}
                        >
                          <Input
                            type="number"
                            readOnly
                            style={{ width: "100px" }}
                            className="disabled-input"
                            value={"69"}
                          />

                          <strong >
                            Total Price

                          </strong></div>
                      </>
                    )} */}


                </div>

                {(() => {
                  const hasAnySampleStock = filteredOptions.some(option => (stock[option?.skucode]?.sampleQuantity ?? 0) > 0);

                  return selectedOrderType === "WHOLESALE" ? (
                    <button
                      className="button-add-to-cart btn btn-primary btn-block f-16 m-t-16 block-when-wide"
                      style={{
                        height: "52px",
                        cursor:
                          selectedValues.length == 0 ||
                            selectedValues.every((id) => {
                              const variant = variantOrders[id];
                              const minQty = kgPerRoll;

                              return !variant || !variant.kg || variant.kg < minQty;
                            })
                            ? "not-allowed"
                            : "pointer",
                        opacity:
                          selectedValues.length == 0 ||
                            selectedValues.every((id) => {
                              const variant = variantOrders[id];
                              const minQty = kgPerRoll;

                              return !variant || !variant.kg || variant.kg < minQty;
                            })
                            ? "1"
                            : "1",
                      }}
                      onClick={() => {
                        handleAddToCart();
                      }}
                      disabled={
                        selectedValues.length === 0 ||
                        selectedValues.every((id) => {
                          const variant = variantOrders[id];
                          return (
                            !variant ||
                            !variant.roll ||
                            variant.roll < 1 ||
                            !variant.kg || variant.kg < 1
                          );
                        })
                      }
                    >
                      {filteredOptions.length === 0
                        ? "Wholesale unavailable"

                        : "Add to WholeSale cart"}
                    </button>
                  ) : selectedOrderType === "SAMPLE" ? (
                    hasAnySampleStock ? (
                      <button
                        className="button-add-to-cart btn btn-primary btn-block f-16 m-t-16 block-when-wide"
                        style={{
                          height: "52px",
                          cursor:
                            selectedValues.length == 0 ||
                              selectedValues.every((id) => {
                                const variant = variantOrders[id];
                                const minQty = cartOptions[id]?.SampleMin;
                                const maxQty = cartOptions[id]?.SampleMax;
                                return (
                                  !variant ||
                                  !variant.kg ||
                                  variant.kg < minQty ||
                                  variant.kg > maxQty
                                );
                              })
                              ? "not-allowed"
                              : "pointer",
                          opacity:
                            selectedValues.length == 0 ||
                              selectedValues.every((id) => {
                                const variant = variantOrders[id];
                                const minQty = cartOptions[id]?.SampleMin;
                                const maxQty = cartOptions[id]?.SampleMax;
                                return (
                                  !variant ||
                                  !variant.kg ||
                                  variant.kg < minQty ||
                                  variant.kg > maxQty
                                );
                              })
                              ? "1"
                              : 1,
                        }}
                        onClick={() => handleAddToCart()}
                        disabled={
                          selectedValues.length === 0 ||
                          selectedValues.every((id) => {
                            const variant = variantOrders[id];
                            const minQty = cartOptions[id]?.SampleMin;
                            const maxQty = cartOptions[id]?.SampleMax;
                            return (
                              !variant ||
                              !variant.kg ||
                              variant.kg < minQty ||
                              variant.kg > maxQty
                            );
                          })
                        }
                      >
                        {filteredOptions.length === 0
                          ? "Sample unavailable"

                          : "Add to Sample cart"}
                      </button>
                    ) : (
                      <>
                        <div className="swatch-notify" >
                          <span className="swatch-notify-text"
                            onClick={() => {
                              if (!pim?.sampleNotified) {
                                sampleNotify();
                              }
                            }}
                            style={{ cursor: pim?.sampleNotified === true ? "not-allowed" : "pointer", opacity: pim?.sampleNotified === true ? "0.6" : "1" }}
                          >{pim?.sampleNotified === false ? "Sample Notify" : "Sample Notified"}</span>
                        </div>
                        <button
                          className="button-add-to-cart btn btn-primary btn-block f-16 m-t-16 block-when-wide"
                          style={{ height: "52px", cursor: "pointer" }}
                          disabled
                        >
                          Sample Out Of Stock
                        </button>
                      </>
                    )
                  ) : null;
                })()}

                {selectedOrderType === "SWATCH" && (
                  <>
                    <div className="flex p-t-24 b-t">
                      <div className="quality-order-swatch building-block">
                        <div className="building-block-title">Swatch</div>
                        <div className="cart-product-payload-item flex g-8">
                          <div className="row-swatch">
                            <div className="field-name">Colors : </div>
                            <div className="value" style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                              {colorOption?.map((i, index) => (
                                <ColorSwatch
                                  key={index}
                                  color={i.code}
                                  size="0.8rem"
                                  style={{ marginTop: "0.3rem", display: "flex", flexDirection: "row" }}
                                />
                              ))}
                            </div>
                          </div>
                          <div className="row-swatch">
                            <div className="field-name">Points :</div>
                            <div className="value"  style={{display:"flex"}}>
                              {swatch?.swatchPrice
                                ? swatch.swatchPrice
                                : <span style={{ color: "red" }}>Unavailable</span>}

                            </div>
                          </div>
                        </div>
                        {swatchAvailable && (
                          <button
                            className="button-add-to-cart btn btn-primary btn-block f-16 m-t-16 block-when-wide"
                            style={{ height: "52px", cursor: "pointer" }}
                            onClick={handleSwatchCard}
                            disabled={existComboSwatch?.swatch}
                          >
                            {existComboSwatch?.swatch
                              ? "Already in Swatch Cart"
                              : "Add to Swatch Cart"}
                          </button>)}
                      </div>
                    </div>
                    {!swatchAvailable && (
                      <div className="swatch-notify" >
                        <span className="swatch-notify-text"
                          onClick={() => {
                            if (!pim?.swatchNotified) {
                              swatchNotify();
                            }
                          }}
                          style={{ cursor: pim?.swatchNotified === true ? "not-allowed" : "pointer", opacity: pim?.swatchNotified === true ? "0.6" : "1" }}
                        >{pim?.swatchNotified === false ? "Swatch Notify" : "Swatch Notified"}</span>
                      </div>)}

                    {!swatchAvailable && (
                      <button
                        className="button-add-to-cart btn btn-primary btn-block f-16 m-t-16 block-when-wide"
                        style={{ height: "52px", cursor: "pointer" }}
                        disabled
                      >
                        Swatch Out Of Stock
                      </button>)}
                  </>
                )}


                {isOpenModal && (
                  <div className="modal-overlay">
                    <div className="modal-container">
                      <h2 className="modal-title">Notification</h2>
                      <p className="modal-message">{modalMessage}</p>
                      <div className="modal-actions">
                        {modalMessage ===
                          "You are not approved yet. Please Contact your Sales Manager" ? (
                          <button
                            className="modal-btn ok-btn centered"
                            style={{ marginLeft: "11.2rem" }}
                            onClick={handleCloseModal}
                          >
                            OK
                          </button>
                        ) : (
                          <>
                            <button
                              className="modal-btn cancel-btn"
                              onClick={handleCloseModal}
                            >
                              Cancel
                            </button>
                            {modalMessage ===
                              "You need to log in to add items to the cart." && (
                                <button
                                  className="modal-btn ok-btn"
                                  onClick={handleLoginRedirect}
                                >
                                  OK
                                </button>
                              )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="bottom-section" ref={pricingRef}>
        <div className="width-limiter">
          <div className="quality-detail-accordions">
            <div
              className="qda-tables quality-detail-accordion building-block"
              quality="[object Object]"
              accordion="[object Object]"
            >
              <div className="tables-pricing flex g-8">
                <div className="subtitle">Pricing</div>
                <div className="price-table1">
                  <div className="thead">
                    <div className="col">Range</div>
                    <div className="col">Quantity (Min - Max)</div>
                    <div className="col">Price</div>
                  </div>
                  <div className="tbody flex-fill">
                    {priceSlab?.priceBooks && priceSlab?.priceBooks?.map((item2, index) => (
                      console.log("item2", item2),
                      item2?.priceSlab?.sort((a, b) => {
                        if (a.orderType !== b.orderType) {
                          return a.orderType.localeCompare(b.orderType);
                        }
                        if (a.min !== b.min) {
                          return a.min - b.min;
                        }
                        const priceA =
                          (priceSlab.sellingPrice - a.price) * (1 - a.discount / 100);

                        const priceB =
                          (priceSlab.sellingPrice - b.price) * (1 - b.discount / 100);

                        return priceA - priceB;
                      }).map((item, index2) => (
                        <div key={index2} className={ismobile ? "quality-detail-price" : "quality-detail-price row"}>

                          <div className="range">{item.orderType}</div>

                          <div className="range">
                            {item.min || 0} - {item.max || "above"}
                            {/* {isKg === true ? (
                              <small>kgs</small>
                            ) : isMeter === true ? (
                              <small>m</small>
                            ) : isYard === true ? (
                              <small>yrd</small>
                            ) : (
                              "-"
                            )} */}
                          </div>

                          <div className="price">
                            <div className="">
                              <span>
                                &#8377;  {_.round((priceSlab?.sellingPrice - item?.price) * (1 - item.discount / 100), 2)}
                              </span>
                              {isKg === true ? (
                                <small>/kgs</small>
                              ) : isMeter === true ? (
                                <small>/m</small>
                              ) : isYard === true ? (
                                <small>/yrd</small>
                              ) : (
                                "-"
                              )}
                            </div>
                          </div>
                        </div>))
                    ))}
                  </div>
                </div>
              </div>
              {/* <div className="tables-moq flex g-8" ref={moqRef}>
                <div className="subtitle">MOQ</div>

                <div className="price-table2">
                  <div className="price-table-body">
                    <div className="thead">
                      <div className="col">Order</div>
                      <div className="col">MOQ</div>
                      <div className="col">Lead Time</div>
                    </div>
                    <div className="tbody flex-fill">
                      {priceSlab?.map((item, index) => (
                        <div key={index} className="quality-detail-price row">
                          <div className="range">{item.orderType}</div>
                          <div className="range">
                            {item.min} - {item.max}
                            {isKg === true ? (
                              <small>/kgs</small>
                            ) : isMeter === true ? (
                              <small>meter</small>
                            ) : isYard === true ? (
                              <small>yard</small>
                            ) : (
                              "-"
                            )}
                          </div>
                          <div className="price">
                            <div className="">
                              <span>
                                {leadTImeFunction(item)
                                  ? `${leadTImeFunction(item)} days`
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
            <div
              className="qda-fabric-specification quality-detail-accordion building-block"
              ref={fabricSpecsRef}
            >
              <div className="qda-header">Fabric Specifications</div>
              <div className="qda-items">
                <div className="qda-item">
                  <div className="key">Fabric Type</div>
                  <h1 className="value"  style={{display:"flex"}}>
                    <div className="t-fabric-spec">
                      <span className="item category">
                        <DisplayHierarchy />
                      </span>
                    </div>
                  </h1>
                </div>

                <div className="qda-item">
                  <h2 className="key">Fiber Content</h2>
                  <h3 className="value"  style={{display:"flex"}}>
                    <div
                      className="t-fabric-spec"
                      style={{
                        display: "flex",
                        gap: "0.5rem",
                        position: "absolute",
                        textDecoration: "none",
                      }}
                    >
                      {Object.entries(fabricCodes)
                        .map(([key, value]) => {
                          const [fabric, code] = key.split("(");
                          const CategoryId = code.replace(")", "");
                          const total = Object.values(fabricCodes).reduce((sum, v) => sum + v, 0);
                          const percentage = Math.round((value / total) * 100);

                          return {
                            fabric: fabric.trim(),
                            CategoryId,
                            percentage,
                          };
                        })
                        .sort((a, b) => b.percentage - a.percentage)
                        .map((item, index, arr) => (
                          <span key={item.fabric} style={{ display: "flex", gap: "0.5rem" }}>
                            <span style={{ cursor: "pointer" }}>
                              <a
                                className="c-gray-600 m-l-4"
                                onClick={() =>
                                  handleFabricFilterClick(item.fabric, item.CategoryId)
                                }
                              >
                                {item.fabric}
                                <span className="c-gray-600 m-l-4">{item.percentage}%</span>
                              </a>
                            </span>

                            {index < arr.length - 1 && (
                              <span>
                                <span className="c-gray-600 m-l-4">/</span>
                              </span>
                            )}
                          </span>
                        ))}
                    </div>
                  </h3>
                  <br />
                </div>


                {solidPatternVariant !== null && (
                  <div className="fabric-specification-section qda-item">
                    <h2 className="key">Solid / Pattern</h2>
                    <div className="value gridable" style={{display:"flex"}}>
                        <div className="gridable-content" style={{display:"flex"}}>
                          <h4>{solidPatternVariant.value}</h4>
                        </div>
                    </div>
                  </div>
                )}

                <div className="qda-item">
                  <div className="key">Dimensions</div>
                  <div className="value" style={{display:"flex"}}>
                    <div className="metrics">
                      <div>
                        <div>{pim?.product?.metrics?.weight || "N/A"} gsm</div>
                        <div className="what">Weight</div>
                      </div>
                      <div>
                        <div>{pim?.product?.metrics?.width || "N/A"} in</div>
                        <div className="what">Width</div>
                      </div>
                      <div>
                        <div>
                          {pim?.product?.metrics?.thickness || "N/A"} mm
                        </div>
                        <div className="what">Thickness</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Attributes Section - Fixed for Characteristics */}
                {pim?.attributes &&
                  Object.entries(pim.attributes)
                    .filter(([key]) => key !== "Fabric Type" && key !== "Fabric Content")
                    .map(([key, value]) => {
                      if (!value) return null;

                      // Use heirarchyLabel if available, otherwise fallback to name
                      const displayLabel = value.heirarchyLabel || value.name || key;
                      const hasParentChild = value.heirarchyLabel?.includes("/");

                      const [parentName, childName] = hasParentChild
                        ? value.heirarchyLabel.split("/").map((part) => part.trim())
                        : [displayLabel];

                      return (
                        <div
                          className="fabric-specification-section qda-item"
                          key={key}
                        >
                          <h2 className="key">{key}</h2>
                          <div className="value gridable"  style={{display:"flex"}}>
                              <div className="gridable-key" style={{display:"flex"}}>
                                <h4>
                                  {hasParentChild
                                    ? `${parentName} > ${childName}`
                                    : parentName}
                                </h4>
                              </div>
                              {value.description && (
                                <div className="gridable-content" style={{display:"flex"}}>
                                  {value.description}
                                </div>
                              )}
                          </div>
                        </div>
                      );
                    })}
                {pim?.productCategoriesList &&
                  Object.entries(
                    pim.productCategoriesList.reduce((acc, item) => {
                      const group = item.productGroupName || "Null";
                      if (!acc[group]) acc[group] = [];
                      acc[group].push(item.name);
                      return acc;
                    }, {})
                  ).map(([groupName, names]) => (
                    <div key={groupName} className="fabric-specification-section qda-item">
                      <h2 className="key">{groupName}</h2>
                      <div className="value gridable" style={{display:"flex"}}>
                        {names.join(" , ")}
                      </div>
                    </div>
                  ))}


                {pim &&
                  pim.attributes &&
                  pim.attributes["Fabric Type"]?.description ? (
                  <div className="fabric-specification-section qda-item">
                    <h2 className="key">Care Advice</h2>
                    <div className="value gridable two-columns"  style={{display:"flex"}}>
                        <div className="gridable-key" style={{display:"flex"}}>
                          <DisplayHierarchy />
                        </div>
                        <div className="gridable-content" style={{display:"flex"}}>
                          {pim.attributes["Fabric Type"].description}
                        </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="for-system-view">
              <div className="qda-products quality-detail-accordion building-block">
                <h2 className="qda-header">
                  {_.size(pim.pimVariants)} Standard Colors
                </h2>
                <div className="grid m-t-24">
                  {_.map(colorOption, (item, index) => (
                    <div key={item?.id || index} className="qda-product-card">
                      <div className="product-image-container" onClick={() => {
                        const index = colorOption.findIndex((x) => x.id === item.id);
                        setSelectedImage(item);
                        setImageIndex(index);
                      }}>
                        <img
                          className="app-img cover overlay"
                          src={`${BASE_URL}${item.image?.replace("/api", "")}?time=${Date?.now()}`}
                          alt={item.skucode}
                          loading="lazy"
                          draggable="false"
                        />
                        <div className="additional-price"></div>
                        <div
                          className="see-big center overlay"
                          style={{ pointerEvents: "none", zIndex: 5 }}
                        >
                          <FontAwesomeIcon
                            icon={faMagnifyingGlassPlus}
                            style={{ fontSize: '1.5rem', cursor: 'pointer', color: 'white', pointerEvents: 'auto' }}
                            onClick={() => {
                              const index = colorOption.findIndex((x) => x.id === item.id);
                              setSelectedImage(item);
                              setImageIndex(index);
                            }}
                          />
                        </div>

                        <div
                          className="icon-overlay"
                          style={{
                            position: "absolute",
                            top: "8px",
                            right: "8px",
                            pointerEvents: "auto",
                          }}
                        >
                          <ActionIcon
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleWishlist(item?.id, null, item?.color);
                            }}
                            aria-label="Toggle Wishlist"
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "9999px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backdropFilter: "blur(8px)",
                              WebkitBackdropFilter: "blur(8px)",
                              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                              transition: "all 0.3s ease",
                              cursor: "pointer",
                              border: "none",
                              backgroundColor: _.includes(pimVariantIds, item?.id)
                                ? "#fee2e2"
                                : "rgba(255,255,255,0.8)",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "scale(1.1)";
                              e.currentTarget.style.backgroundColor = _.includes(pimVariantIds, item?.id)
                                ? "#fecaca"
                                : "#ffffff";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "scale(1)";
                              e.currentTarget.style.backgroundColor = _.includes(pimVariantIds, item?.id)
                                ? "#fee2e2"
                                : "rgba(255,255,255,0.8)";
                            }}
                            onMouseDown={(e) => {
                              e.currentTarget.style.transform = "scale(0.95)";
                            }}
                            onMouseUp={(e) => {
                              e.currentTarget.style.transform = "scale(1.1)";
                            }}
                          >
                            <IconHeart
                              style={{
                                width: "20px",
                                height: "20px",
                                transition: "all 0.3s ease",
                                color: _.includes(pimVariantIds, item?.id)
                                  ? "#ef4444"
                                  : "#4b5563",
                                fill: _.includes(pimVariantIds, item?.id)
                                  ? "#f80b0b"
                                  : "none",
                              }}
                            />
                          </ActionIcon>
                        </div>
                      </div>
                      <div className="m-t-8">
                        <div className="lines-1 product-title">
                          <span>#{index + 1}</span>
                          <span className="m-l-4">{item.color}</span>
                        </div>
                        <div className="pd-code">{item.sku}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="for-mobile-view">
              <div className="qda-products-det">
                <h2 className="qda-header">
                  {_.size(pim.pimVariants)} Standard Colors
                </h2>
                <div className="grid-mobile-pro">
                  {_.map(colorOption, (item, index) => (
                    <div key={item?.id || index} className="qda-product-card-mob">
                      <div className="product-image-container-mob" onClick={() => {
                        const index = colorOption.findIndex((x) => x.id === item.id);
                        setSelectedImage(item);
                        setImageIndex(index);
                      }}>
                        <img
                          className="app-img cover overlay"
                          src={`${BASE_URL}${item.image?.replace("/api", "")}?time=${Date?.now()}`}
                          alt={item.skucode}
                          loading="lazy"
                          draggable="false"
                        />
                        <div className="additional-price"></div>
                        <div
                          className="see-big center overlay"
                          style={{ pointerEvents: "none", zIndex: 9999 }}
                        >
                          <FontAwesomeIcon
                            icon={faMagnifyingGlassPlus}
                            style={{ fontSize: '1.5rem', cursor: 'pointer', color: 'white', pointerEvents: 'auto' }}
                            onClick={() => {
                              const index = colorOption.findIndex((x) => x.id === item.id);
                              setSelectedImage(item);
                              setImageIndex(index);
                            }}
                          />
                        </div>

                        <div
                          className="icon-overlay"
                          style={{
                            position: "absolute",
                            top: "8px",
                            right: "8px",
                            pointerEvents: "auto",
                          }}
                        >
                          <ActionIcon
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleWishlist(item?.id, null, item?.color);
                            }}
                            aria-label="Toggle Wishlist"
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "9999px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backdropFilter: "blur(8px)",
                              WebkitBackdropFilter: "blur(8px)",
                              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                              transition: "all 0.3s ease",
                              cursor: "pointer",
                              border: "none",
                              backgroundColor: _.includes(pimVariantIds, item?.id)
                                ? "#fee2e2"
                                : "rgba(255,255,255,0.8)",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "scale(1.1)";
                              e.currentTarget.style.backgroundColor = _.includes(pimVariantIds, item?.id)
                                ? "#fecaca"
                                : "#ffffff";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "scale(1)";
                              e.currentTarget.style.backgroundColor = _.includes(pimVariantIds, item?.id)
                                ? "#fee2e2"
                                : "rgba(255,255,255,0.8)";
                            }}
                            onMouseDown={(e) => {
                              e.currentTarget.style.transform = "scale(0.95)";
                            }}
                            onMouseUp={(e) => {
                              e.currentTarget.style.transform = "scale(1.1)";
                            }}
                          >
                            <IconHeart
                              style={{
                                width: "20px",
                                height: "20px",
                                transition: "all 0.3s ease",
                                color: _.includes(pimVariantIds, item?.id)
                                  ? "#ef4444"
                                  : "#4b5563",
                                fill: _.includes(pimVariantIds, item?.id)
                                  ? "#f80b0b"
                                  : "none",
                              }}
                            />
                          </ActionIcon>
                        </div>
                      </div>
                      <div className="mob-index">
                        <div className="pro-mob-title">
                          <span>#{index + 1}</span>
                          <span className="mob-color-pro">{item.color}</span>
                        </div>
                        <div className="pd-code">{item.sku}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {similarProduct.length > 0 && (
        <div className="similar-items building-block width-limiter">
          <div className="title">Similar Products</div>{" "}
          <Carousel
            slideSize={ismobile ? "50%" : "15%"}
            loop
            slideGap="md"
            align="start"
            slidesToScroll={ismobile ? 2 : 5}
          >
            {similarProductSlide}
          </Carousel>
        </div>
      )}

      <TopBottomCollectionsPMC />
      <div>
      </div>
      {selectedImage && (
        <div className="image-zoom-overlay" onClick={() => setSelectedImage(null)}>
          <div className="zoom-wrapper" onClick={(e) => e.stopPropagation()}>
            <div
              className="left-iconn"
              style={{ visibility: imageIndex > 0 ? 'visible' : 'hidden' }}
              onClick={(e) => {
                e.stopPropagation();
                if (imageIndex > 0) scrollLeftIcon();
              }}
            >
              <FontAwesomeIcon
                className="i far"
                icon={faChevronLeft}
              />
            </div>

            <div className="zoom-content">
              <img
                src={`${BASE_URL}${selectedImage.image?.replace("/api", "")}?time=${Date?.now()}`}
                alt={selectedImage.skucode}
                className="zoom-image"
              />
              <div className="color-code">
                <strong>{selectedImage.label}</strong>
              </div>
              <div className="color-code2">
                {imageIndex + 1}/{colorOption.length}
              </div>
              <div
                className="color-code3"
                onClick={() => {
                  const matched = media.find(
                    (m) =>
                      m.src?.includes(selectedImage.image?.replace("/api", "")) ||
                      m.poster?.includes(selectedImage.image?.replace("/api", ""))
                  );
                  if (matched) {
                    setMainContent(matched);
                    setSelectedImage(null);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                }}
              >
                Select
              </div>
            </div>

            <div
              className="right-iconn"
              style={{ visibility: imageIndex < colorOption.length - 1 ? 'visible' : 'hidden' }}
              onClick={(e) => {
                e.stopPropagation();
                if (imageIndex < colorOption.length - 1) scrollRightIcon();
              }}
            >
              <FontAwesomeIcon
                className="i far"
                icon={faChevronRight}
              />
            </div>
          </div>
        </div>
      )}
      {selectedImageTop && (
        <div className="image-zoom-overlay" onClick={() => setSelectedImageTop(null)}>
          <div className="zoom-content">
            <img
              src={`${BASE_URL}${selectedImageTop.image?.replace("/api", "")}?time=${Date?.now()}`}
              alt={selectedImageTop.skucode}
              className="zoom-image"
            />
            <div className="color-codeZoom">
              <strong>{selectedImageTop.label}</strong>
            </div>
          </div>
        </div>

      )}

      <Modal
        opened={opened}
        onClose={close}
        withCloseButton={true}
        overlayProps={{
          backgroundOpacity: 0.55,
          blur: 3,
        }}
        classNames={{
          content: "thankyou-modal-content",
        }}
      >
        <span>
          <strong className="thankyou-title">
            Thank You for Shopping with us
          </strong>
        </span>
        <br />
        <div>
          {itemAdded && (
            <div className="thankyou-buttons">
              <B2BButton
                className="btn btn-primary btn-block f-16 m-t-10"
                onClick={() => navigate("/fabrics")}
                name={"Continue Sourcing"}
                color="#8BC53F"
              />
              <B2BButton
                className="btn btn-primary btn-block f-16 m-t-10"
                onClick={() => navigate(`/cart?tab=${selectedOrderType}`)}
                name={"Go to Cart"}
                color="gray"
              />
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};
